// Auto-extracted from lib/i18n.js on refactor — do not hand-edit if you
// can help it; keep the same style + comment layout as the other dicts.
const nl = {
    appName: "JobGrid",
    tagline: "Personal Application Tracker",
    appliedStatus: "Gesolliciteerd",
    savedStatus: "Nog niet gesolliciteerd",
    invitedStatus: "Uitgenodigd",
    clarificationStatus: "Verduidelijking gevraagd",
    clarificationShortStatus: "Verduidelijking",
    hiredStatus: "Aangenomen",
    rejectedStatus: "Helaas",
    channelLinkedIn: "LinkedIn",
    channelRecruiter: "Recruiter",
    channelOpen: "Open sollicitatie",
    typeIncompany: "In-house",
    typeFreelance: "Freelance",
    typeOutsourced: "Detachering",
    rateHourly: "Per uur",
    rateDaily: "Per dag",
    rateMonthly: "Per maand",
    cancel: "Annuleren",
    save: "Opslaan",
    saving: "Opslaan…",
    add: "Toevoegen",
    edit: "Bewerken",
    view: "Bekijken",
    delete: "Verwijderen",
    logout: "Uitloggen",
    loading: "Laden…",
    confirmTitle: "Weet je het zeker?",
    confirmConfirm: "Bevestigen",
    confirmCancel: "Annuleren",
    all: "Alle",

    // Login — title/slogan/eyebrow/footer kept in English by design
    loginEdition: "Volume II · Van vacature tot aanbod",
    loginH1A: "Van",
    loginH1Applications: "vacature",
    loginH1B: "direct naar de",
    loginH1C: "",
    loginH1Conversations: "motivatiebrief",
    loginH1D: "— via een",
    loginH1E: "",
    loginH1Offers: "CV",
    loginH1F: "dat matcht. In één rustige app.",
    loginBody:
      "Zoek vacatures over LinkedIn, Indeed, Adzuna, Jobbird, Twago en meer — vink één aan en schrijf direct een motivatiebrief met AI. Je CV past zich automatisch aan, en de interview-prep staat klaar zodra je nodig hebt. Alles op één plek, gratis om te starten.",
    loginContinueGoogle: "Doorgaan met Google",
    loginGoogleSignin: "Inloggen met Google",
    loginGoogleRegister: "Registreren met Google",
    emailAuthOr: "of via e-mail",
    emailAuthEmail: "E-mailadres",
    emailAuthPassword: "Wachtwoord",
    emailAuthChoosePassword: "Kies een wachtwoord",
    emailAuthConfirmPassword: "Bevestig wachtwoord",
    emailAuthNewPassword: "Nieuw wachtwoord",
    emailAuthPwHint: "Minimaal 8 tekens, met letters én cijfers.",
    emailAuthLoginCta: "Inloggen",
    emailAuthRegisterCta: "Account aanmaken",
    emailAuthTabRegister: "Nieuw account",
    emailAuthTabSignin: "Bestaand account",
    emailAuthVerifyCta: "Verifiëren",
    emailAuthForgotCta: "Stuur reset-code",
    emailAuthResetCta: "Wachtwoord instellen",
    emailAuthForgotLink: "Wachtwoord vergeten?",
    emailAuthRegisterLink: "Nog geen account?",
    emailAuthResendLink: "Opnieuw versturen",
    emailAuthBackToLogin: "Terug naar inloggen",
    emailAuthCodeLabel: "6-cijferige code",
    emailAuthVerifyIntro: "We hebben een code gestuurd naar",
    emailAuthForgotIntro: "Geen probleem — vul je e-mailadres in, dan sturen we je een 6-cijferige resetcode.",
    emailAuthResetIntro: "Vul de code in die we net gemaild hebben naar",
    emailAuthCodeSent: "Verificatiecode verstuurd — check je inbox.",
    emailAuthCodeResent: "Nieuwe code onderweg.",
    emailAuthResetSent: "Reset-code verstuurd (als het adres bekend is).",
    emailAuthResetOk: "Wachtwoord ingesteld — welkom terug.",
    emailAuthWelcome: "Welkom bij JobGrid.",
    emailAuthNeedsVerify: "Bevestig eerst je e-mailadres.",
    emailAuthMismatch: "De wachtwoorden komen niet overeen.",
    emailAuthLoginFailed: "Inloggen mislukt.",
    emailAuthRegisterFailed: "Registratie mislukt.",
    emailAuthVerifyFailed: "Ongeldige of verlopen code.",
    emailAuthResetFailed: "Wachtwoord resetten mislukt.",
    emailAuthGeneric: "Er ging iets mis, probeer het opnieuw.",
    loginDisclaimer: "Door door te gaan beloof je voor jezelf te blijven opdagen.",
    loginInThisIssue: "In deze editie",
    loginItem1T: "Archiveer de omschrijving",
    loginItem1D: "Plak de URL — de tekst van de vacature wordt bewaard.",
    loginItem2T: "Volg elk kanaal",
    loginItem2D: "LinkedIn, recruiter (met naam), of open sollicitatie — allemaal op één plek.",
    loginItem3T: "Tarief, type en voorwaarden",
    loginItem3D: "EUR-tarieven voor in-house, detachering en freelance. Per uur, dag of maand instelbaar.",
    loginItem4T: "Gesprekken en notities",
    loginItem4D: "Agenda, contacten en persoonlijke notities blijven bij het record.",
    loginLegend: "Status-legenda",
    loginFooterL: "Volume I · MMXXVI",
    loginFooterR: "Set in Cormorant Garamond & Satoshi",
    languageLabel: "Taal",
    languageUiSection: "App-taal",
    languageAiSection: "AI genereert in 8 talen",
    languageAiHint: "Schrijf je CV in het Nederlands en genereer de brief in elke gewenste taal.",
    // Homepage USP banner
    langUspTitle: "Solliciteer in 8 talen — vanuit je eigen taal",
    langUspBody: "Jouw CV blijft in het Nederlands, maar AI genereert je motivatiebrief, interview-prep en publieke CV automatisch in Nederlands, English, Deutsch, Français, Español, Polski, Türkçe of العربية. Ideaal voor internationale sollicitaties.",

    dashOverviewTitle: "Sollicitatieoverzicht",
    dashHeading1: "sollicitatie",
    dashHeadingN: "sollicitaties",
    dashSubtitle: "Jouw sollicitaties",
    dashAddApplication: "Sollicitatie toevoegen",
    dashSearch: "Zoek op functie of bedrijf…",
    dashLabelStatus: "Status",
    dashLabelChannel: "Kanaal",
    dashLabelType: "Type",
    dashLabelSort: "Sorteer op",
    dashSortRecent: "Datum · nieuwste eerst",
    dashSortOldest: "Datum · oudste eerst",
    dashSortMatchDesc: "Match-score · hoog → laag",
    dashSortMatchAsc: "Match-score · laag → hoog",
    dashColMatch: "Match",
    dashColMatchHint: "AI-match-score op basis van je CV vs. de vacature. Klik op een rij om het volledige inzicht te zien.",
    dashMatchNotYet: "Open deze vacature om een AI-match-inzicht te genereren",
    dashBulkInsightsBtn: "AI-inzichten voor alle",
    dashBulkInsightsBusy: "Genereren…",
    dashBulkInsightsHint: "Genereer een AI-match-score voor je actieve vacatures die er nog geen hebben (max 15 per klik).",
    dashBulkInsightsDone: "{n} inzichten gegenereerd",
    dashBulkInsightsMore: "{n} vacatures nog te doen",
    dashBulkInsightsAlerts: "{n} sterke matches gemaild",
    dashBulkInsightsFailed: "Bulk-generatie mislukt — probeer het later opnieuw.",
    // Match-alert preferences
    prefMatchAlertsEyebrow: "Sterke-match meldingen",
    prefMatchAlertsTitle: "E-mail als AI Match Insight ≥ drempel scoort",
    prefMatchAlertsBody: "Zodra JobGrid een vacature vindt die goed bij je CV past, sturen we je een korte mail met de score en de belangrijkste redenen. Elke vacature krijgt maximaal één alert.",
    prefMatchAlertsToggle: "Meldingen inschakelen",
    prefMatchAlertThreshold: "Alert-drempel",
    prefMatchAlertSaved: "Voorkeur opgeslagen",
    dashLoading: "Sollicitaties laden…",
    dashEmptyTitleBlank1: "De pagina is",
    dashEmptyTitleBlank2: "leeg",
    dashEmptyTitleNo1: "Geen",
    dashEmptyTitleNo2: "resultaten",
    dashEmptyBlankBody: "Voeg je eerste sollicitatie toe — plak een URL of vul het formulier in.",
    dashEmptyNoBody: "Pas de filters aan om resultaten te zien.",
    dashEmptyAddFirst: "Voeg je eerste toe",
    dashColPosition: "Functie",
    dashColCompany: "Bedrijf",
    dashColStatus: "Status",
    dashColDate: "Datum",
    dashColChannel: "Kanaal",
    dashColActions: "Acties",
    dashActionsMenu: "Actie menu",
    dashConfirmDelete: "Deze sollicitatie verwijderen?",
    dashDeleted: "Sollicitatie verwijderd",
    dashViewActive: "Actief",
    dashViewArchive: "Archief",
    dashArchive: "Archiveer sollicitatie",
    dashUnarchive: "Herstel naar actief",
    dashArchived: "Naar archief verplaatst",
    dashUnarchived: "Teruggezet als actief",
    dashArchiveFailed: "Kon niet archiveren. Probeer het opnieuw.",
    dashArchiveNoticeEyebrow: "Archief · éénmalige info",
    dashArchiveNoticeTitle: "Sollicitaties worden max. 1 jaar bewaard",
    dashArchiveNoticeBody: "Zodra je een sollicitatie archiveert blijft deze 365 dagen zichtbaar in je archief. Daarna wordt hij automatisch definitief verwijderd. Je kunt gearchiveerde items altijd terugzetten naar 'Actief' zolang ze nog in het archief staan.",
    dashArchiveNoticeAccept: "Akkoord",
    dashArchiveRetentionShort: "Max. 1 jaar bewaard · daarna automatisch verwijderd",
    dashBulkSelect: "Selecteer sollicitatie",
    dashBulkDeselect: "Deselecteer sollicitatie",
    dashBulkSelectPage: "Selecteer alles op deze pagina",
    dashBulkDeselectPage: "Deselecteer alles op deze pagina",
    dashBulkSelectedOne: "sollicitatie geselecteerd",
    dashBulkSelectedN: "sollicitaties geselecteerd",
    dashBulkArchiveCta: "Archiveer geselecteerde",
    dashBulkUnarchiveCta: "Herstel geselecteerde",
    dashBulkClear: "Selectie leegmaken",
    dashBulkArchived: "{count} sollicitaties gearchiveerd",
    dashBulkUnarchived: "{count} sollicitaties hersteld",
    dashArchiveExportPdfHint: "Download je archief als PDF (A4 landschap)",
    dashArchiveExportXlsxHint: "Download je archief als Excel-bestand",
    dashArchiveExporting: "Bezig…",
    dashArchiveExportDone: "Archief-export gedownload",
    dashArchiveExportFailed: "Export mislukt — probeer het nogmaals.",
    dashLoadFailed: "Sollicitaties laden mislukt",
    dashDeleteFailed: "Verwijderen mislukt",

    bmTitle: "Favoriete vacaturesites",
    bmSubtitle: "Snelle toegang tot je vaste bronnen",
    bmAdd: "Toevoegen",
    bmAdding: "Toevoegen…",
    bmName: "Naam",
    bmNamePh: "bv. LinkedIn Jobs",
    bmUrl: "URL",
    bmUrlPh: "https://…",
    bmOpen: "Openen",
    bmOpenNew: "Openen in nieuw tabblad",
    bmRemove: "Verwijderen",
    bmEmpty: "Nog geen favorieten. Voeg je vaste vacaturesites toe.",
    bmConfirmDelete: "Deze bookmark verwijderen?",
    bmCreated: "Bookmark opgeslagen",
    bmDeleted: "Bookmark verwijderd",
    bmCreateFailed: "Bookmark opslaan mislukt",
    bmDeleteFailed: "Verwijderen mislukt",
    bmLoadFailed: "Bookmarks laden mislukt",
    bmRequired: "Naam en URL zijn verplicht",

    // CV & Interview prep
    cvTitle: "Mijn CV",
    cvSubtitle: "Standaard CV — gebruikt voor interviewvoorbereiding wanneer er geen specifiek CV per sollicitatie is",
    cvUpload: "CV uploaden",
    cvUploading: "Uploaden…",
    cvReplace: "Vervangen",
    cvRemove: "Verwijderen",
    cvNone: "Nog geen CV geüpload.",
    cvUploaded: "CV opgeslagen",
    cvDeleted: "CV verwijderd",
    cvUploadFailed: "CV uploaden mislukt",
    cvHint: "PDF of DOCX, max 5 MB",
    cvCentralTitle: "Standaard CV — kies bron",
    cvCentralHint: "Selecteer één van je aangemaakte CV-varianten. Deze wordt gebruikt voor interviewvoorbereiding en criterium-matching wanneer je nog geen CV per sollicitatie hebt geüpload.",
    cvCentralNone: "Geüpload CV-bestand hierboven gebruiken",
    cvCentralUnnamed: "(zonder naam)",
    cvCentralSaved: "Standaard CV bijgewerkt",
    cvCentralSaveFailed: "Kon standaard CV niet bijwerken",
    cvDefaultNote: "Markeer één van de CV's hieronder met de ster om deze als standaard te gebruiken. Deze wordt automatisch ingezet voor interviewvoorbereiding en criterium-matching wanneer je nog geen specifiek CV per sollicitatie hebt.",
    cvUpdatedAt: "Bijgewerkt",
    cvConfirmDelete: "Dit CV verwijderen?",

    prepButton: "Prep",
    prepTitle: "Interviewvoorbereiding",
    prepFor: "voor",
    prepGenerate: "Genereer voorbereiding",
    prepRegenerate: "Opnieuw genereren",
    prepGenerating: "Bezig met genereren (kan 30-60 sec duren)…",
    prepGeneratedAt: "Gegenereerd op",
    prepUsingCentralCv: "Op basis van je standaard CV",
    prepUsingJobCv: "Op basis van CV specifiek voor deze sollicitatie",
    prepNoCv: "Geen CV — voeg er één toe voor betere resultaten",
    prepUploadJobCv: "CV voor deze sollicitatie",
    prepDownloadPdf: "Download PDF",
    prepPrint: "Printen",
    prepEmail: "E-mail",
    prepWhatsapp: "WhatsApp",
    prepIncludeCv: "CV bijvoegen",
    prepIncludeCvHint: "Alleen als je CV een PDF is — DOCX wordt overgeslagen",
    prepEmailSubject: "Interviewvoorbereiding — {company}",
    prepEmailBody: "Hallo,\n\nBijgevoegd de interviewvoorbereiding voor mijn sollicitatie bij {company} ({job_title}).\n\nMet vriendelijke groet,",
    prepWhatsappText: "Interviewvoorbereiding voor {company} — {job_title}",
    prepShareUnsupported: "Delen via bestand niet ondersteund in deze browser — PDF wordt gedownload.",
    prepDownloading: "PDF genereren…",
    prepShareHint: "Sla op, print, e-mail of deel via WhatsApp",
    prepNone: "Nog geen voorbereiding gegenereerd. Klik hierboven om te starten.",
    prepFailed: "Genereren mislukt — probeer opnieuw",
    prepLangMismatch: "Deze voorbereiding is in {stored}. Klik op 'Opnieuw genereren' om in {current} te maken.",
    prepClose: "Sluiten",
    prepSectionIntro: "Introductie",
    prepSectionMission: "Waar staat het bedrijf voor",
    prepSectionActivities: "Wat doet het bedrijf",
    prepSectionMedia: "In de media",
    prepSectionCvFit: "Hoe mijn CV aansluit",
    prepSectionCompetencies: "Competenties en eisen",
    prepSectionQuestions: "Vragen om te stellen",
    prepSectionTalking: "Gesprekspunten",
    prepSectionClosing: "Afsluitende adviezen",

    addSheetEyebrow: "Nieuw record",
    addSheetTitle: "Sollicitatie toevoegen",
    addSec1: "I · Bron",
    addSec2: "II · De functie",
    addSec3: "III · Agenda",
    addSec4: "IV · Omschrijving (gearchiveerd)",
    addSec5: "V · Notities",
    addUrl: "Vacature-URL",
    addScrape: "Ophalen",
    addScraping: "Ophalen…",
    addScrapeHelp:
      "Plak een vacature-URL. We proberen titel en omschrijving op te halen. Bewerk of plak hieronder handmatig.",
    addPaste: "Plakken",
    addPasteHint: "Plak de URL vanaf je klembord",
    addPasted: "URL geplakt vanaf klembord.",
    addPasteEmpty: "Je klembord is leeg — kopieer eerst een URL.",
    addPasteDenied: "Kan klembord niet openen — kopieer en plak handmatig (Ctrl/⌘+V).",
    addPosition: "Functie *",
    addCompany: "Bedrijf",
    addCompanyPlaceholder: "Naam bedrijf (optioneel)",
    optionalLabel: "optioneel",
    addStatus: "Status",
    addDate: "Sollicitatiedatum",
    addChannel: "Kanaal *",
    addRecruiterName: "Naam recruiter *",
    addJobType: "Type",
    addRate: "Tarief (€)",
    addRateType: "Tarief-type",
    addLocation: "Locatie",
    addSalary: "Salarisrange",
    addContact: "Contactpersoon",
    addContactPh: "Naam · E-mail · Telefoon",
    addInterviewDates: "Sollicitatiedata",
    addHoursPerWeek: "Uren per week",
    addHoursPerWeekPh: "bv. 40",
    addDescription: "Functieomschrijving",
    addDescriptionPh: "Plak handmatig als ophalen mislukt…",
    addNotesLabel: "Persoonlijke notities",
    addNotesPh: "Wat viel je op? Wie nam contact op?",
    addSaveApplication: "Sollicitatie opslaan",
    addRequired: "Functie en bedrijf zijn verplicht",
    addRecruiterRequired: "Naam recruiter is verplicht",
    addUrlFirst: "Voer eerst een URL in",
    addScrapeOk: "Succesvol opgehaald",
    addScrapeFailed: "Ophalen mislukt: {err}. Plak hieronder handmatig.",
    addScrapeError: "Ophalen mislukt. Plak hieronder handmatig.",
    addCreated: "Sollicitatie toegevoegd",
    addSaveFailed: "Opslaan mislukt",

    detailEyebrow: "Record №",
    detailMoreDetails: "Meer details",
    detailExpand: "Openklappen",
    detailCollapse: "Inklappen",
    detailCurrent: "Huidige status",
    detailDate: "Sollicitatiedatum",
    detailDateEdit: "Klik om datum aan te passen",
    detailDateUpdated: "Sollicitatiedatum bijgewerkt",
    detailDateFailed: "Kon sollicitatiedatum niet bijwerken",
    detailChangeStatus: "Status wijzigen",
    detailMeta: "Gegevens",
    detailCalendar: "Agenda",
    detailNoInterviews: "Geen gesprekken gepland.",
    detailNotes: "Notities",
    detailNoNotes: "Geen notities.",
    detailDescription: "Omschrijving (gearchiveerd)",
    // AI Match Insight (job detail sheet)
    miEyebrow: "AI-MATCHINZICHT · WAAROM PAS JE?",
    miVerdict_strong: "Sterke match",
    miVerdict_good: "Goede match",
    miVerdict_mixed: "Gemengd beeld",
    miVerdict_weak: "Zwakke match",
    miStrengthsHeader: "Wat pleit voor jou",
    miGapsHeader: "Aandachtspunten",
    miRefreshBtn: "Regenereer",
    miRefreshHint: "Nieuwe AI-samenvatting maken op basis van je huidige CV",
    miGeneratedAt: "Gegenereerd op",
    miErrGeneric: "Kon geen inzicht ophalen — probeer het later opnieuw.",
    // Similar-jobs strip (Insight Compare)
    similarStripEyebrow: "OOK BEKEKEN · GELIJKAARDIGE MATCHES",
    similarStripHint: "Deze vacature scoort {s}/100. Vergelijkbare vacatures uit jouw lijst:",
    detailNoDescription: "Geen omschrijving opgeslagen.",
    detailMetaChannel: "Kanaal",
    detailMetaJobType: "Type",
    detailMetaRate: "Tarief",
    detailMetaLocation: "Locatie",
    detailMetaSalary: "Salarisrange",
    detailMetaContact: "Contactpersoon",
    detailMetaHours: "Uren per week",
    dashColContract: "Contract",
    detailUpdated: "Bijgewerkt",
    detailUpdateFailed: "Bijwerken mislukt",
    detailStatusToast: "Status: {status}",
    detailStatusFailed: "Status wijzigen mislukt",
    // "Verduidelijking gevraagd" flow — captures what the employer
    // asked before flipping the status, then routes to the wizard.
    detailClarifyEyebrow: "Werkgever vraagt om verduidelijking",
    detailClarifyAskedAt: "Gevraagd op {when}",
    detailClarifyNoNote: "Nog geen toelichting genoteerd — voeg de vraag van de werkgever hieronder toe.",
    detailClarifyCta: "Verduidelijking uitwerken in Match-Verbeter Wizard",
    detailClarifyCtaHint: "Opent de gekoppelde motivatiebrief en start direct de wizard om de gevraagde eis in je CV/brief te verwerken.",
    detailClarifyEditNote: "Notitie bewerken",
    detailClarifyNoLetter: "Er is nog geen motivatiebrief gekoppeld aan deze sollicitatie. Genereer eerst een brief.",
    detailClarifySaved: "Sollicitatie gemarkeerd als 'Verduidelijking gevraagd'",
    detailClarifyDialogEyebrow: "Nieuwe status",
    detailClarifyDialogTitle: "Wat wil de werkgever verduidelijkt zien?",
    detailClarifyDialogBody: "Noteer de vraag of ontbrekende informatie die de werkgever aandroeg. Deze tekst gebruiken we straks in de Match-Verbeter Wizard om je CV/brief gericht bij te schaven.",
    detailClarifyDialogPh: "Bijv. 'De HR-manager vroeg naar concrete ervaring met scrum-masterrol bij Fintech-klanten.'",
    detailClarifyDialogHint: "Deze notitie is alleen voor jou zichtbaar.",
    detailClarifyDialogSubmit: "Markeren als verduidelijking gevraagd",
    detailLoadFailed: "Sollicitatie laden mislukt",
    detailUrlLabel: "URL",

    // CV panel tabs
    cvTabUpload: "CV-bestand",
    cvTabOverview: "CV overzicht",
    cvTabBuilder: "CV Generator",
    cvOvVariantsTitle: "Jouw CV's",
    cvOvEmpty: "Nog geen CV's aangemaakt.",
    cvOvEmptyHint: "Ga naar de CV Generator om je eerste CV te maken.",
    cvOvClickToEdit: "Klik om te bewerken",
    cvOvSetDefaultCta: "Als standaard markeren",
    cvOvUnsetDefaultCta: "Standaard opheffen",
    cvOvSetDefault: "Standaard CV bijgewerkt",
    cvOvUnsetDefault: "Standaard CV opgeheven",
    cvOvDefault: "Standaard",
    cvOvCopyBadge: "Kopie",
    cvOvCopyBadgeTitle: "Deze CV is een kopie van een andere variant",
    cvOvDupCountTitle: "{count}× gedupliceerd",
    cvOvVacancyBadgeTitle: "Gegenereerd voor vacature: {title}",
    cvOvUpdatedAt: "Bijgewerkt {date}",
    cvOvColName: "Naam",
    cvOvColUpdated: "Bijgewerkt",
    cvOvUploadedBadge: "Zelf toegevoegd",
    cvOvUploadedTitle: "Geüpload extern bestand — niet bewerkbaar",
    cvOvUploadedHint: "Extern PDF/DOCX-bestand · niet bewerkbaar",
    cvOvUploadedFallbackName: "Geüploade CV",
    cvOvUploadedConfirmDelete: "Weet je zeker dat je de geüploade CV wilt verwijderen?",
    cvOvUploadedDeleted: "Geüploade CV verwijderd",
    cvTabLetters: "Motivatiebrieven",

    // Resume builder
    rbTitle: "CV Generator",
    rbSubtitle: "Bouw en beheer meerdere CV-varianten met AI-hulp",
    rbVariants: "Varianten",
    rbNewNamePh: "Naam van variant, bv. Projectleider — algemeen",
    rbCreateEmpty: "Leeg",
    rbImportCentral: "Uit standaard CV",
    rbImportFile: "Uit bestand",
    rbImporting: "AI leest je CV… (20-40 sec)",
    rbNoVariants: "Nog geen CV-varianten. Maak er een aan of importeer je huidige CV.",
    rbConfirmDelete: "Deze CV-variant verwijderen?",
    rbDeleted: "Variant verwijderd",
    rbDuplicate: "Dupliceren",
    rbDuplicated: "Variant gedupliceerd",
    rbConfirmDeleteWithLetters: "Deze CV is gekoppeld aan {count} motivatiebrief/-brieven:",
    rbConfirmDeleteLettersHint: "De brief blijft bestaan, maar verliest zijn CV-koppeling. Doorgaan?",
    rbUndone: "Verwijderen ongedaan gemaakt",
    undo: "Ongedaan maken",
    rbCreated: "Variant aangemaakt",
    rbImported: "CV geïmporteerd — controleer de velden",
    rbImportFailed: "Importeren mislukt",
    rbNameRequired: "Geef de variant eerst een naam",
    rbSave: "Opslaan",
    rbSaved: "CV opgeslagen",
    rbSaveFailed: "Opslaan mislukt",
    rbSelectVariant: "Selecteer of maak links een variant om te bewerken.",
    rbPdfNl: "PDF (NL)",
    rbPdfEn: "PDF (EN)",
    rbPdfBoth: "PDF (Beide)",
    rbPdfDownload: "PDF downloaden",
    rbPdfLang: "Taal",
    rbLangNl: "Nederlands",
    rbLangEn: "Engels",
    rbLangDe: "Duits",
    rbLangFr: "Frans",
    rbLangEs: "Spaans",
    rbPdfGenerating: "PDF genereren…",
    rbPdfHint: "Eerste generatie per taal kan ±30 sec duren (AI-vertaling)",
    rbPdfFailed: "PDF genereren mislukt",
    rbSecPersonal: "Personalia",
    rbSecProfile: "Profiel",
    rbSecSkills: "Vaardigheden",
    rbSecExperience: "Werkervaring",
    rbSecEducation: "Opleiding",
    rbSecExtra: "Extracurriculaire activiteiten",
    rbSecReferences: "Referenties",
    rbFullName: "Volledige naam",
    rbJobTitle: "Titel / functie",
    profAddressStreet: "Straat",
    profAddressNumber: "Huisnummer",
    profPostalCode: "Postcode",
    profCity: "Plaats",
    profCountry: "Land",
    rbAddress: "Adres",
    rbNationality: "Nationaliteit",
    rbPhone: "Telefoon",
    rbEmail: "E-mail",
    rbLinkedin: "LinkedIn",
    rbProfilePh: "Korte professionele samenvatting…",
    rbProfileWizard: "Profiel-wizard",
    rbSkillPh: "bv. Stakeholdermanagement",
    rbAddExperience: "Ervaring toevoegen",
    rbAiOptimize: "AI-suggestie",
    rbEduTitle: "Opleiding / cursus",
    rbEduInstitution: "Instituut",
    rbEduYear: "Jaar",
    rbAddEducation: "Opleiding toevoegen",
    rbAddExtra: "Activiteit toevoegen",
    rbReferencesPh: "bv. Referenties op aanvraag",
    // References multi-select — populates from approved references only.
    rbRefPickPh: "Kies referenties — of laat leeg voor 'Referenties op aanvraag'",
    rbRefSelectedCount: "{n} referentie(s) geselecteerd",
    rbRefRemove: "Verwijder",
    rbRefLoading: "Laden…",
    rbRefEmpty: "Nog geen goedgekeurde referenties. Voeg ze toe onder Instellingen → Referenties.",
    rbRefAllPicked: "Alle beschikbare referenties zijn geselecteerd.",
    rbRefDefault: "Geen selectie → PDF toont 'Referenties op aanvraag' onderaan.",
    rbRefSelectedHint: "Alleen de door de referentie goedgekeurde velden verschijnen op de PDF.",
    rbRefDragHint: "Sleep om de volgorde te veranderen",
    rbSkillDragHint: "Sleep om vaardigheden te sorteren — bovenaan verschijnt eerst op de PDF",
    rbDragHint: "Sleep om deze rij te verplaatsen",
    rbSecPortfolioQr: "Portfolio-QR",
    rbPortfolioQrHelp: "Kies een portfolio om als QR-code linksonderaan de CV te tonen. Recruiters scannen en zien direct je online werk.",
    rbPortfolioQrEmpty: "Nog geen portfolio's aangemaakt. Ga naar het menu-item Portfolio om er één te maken.",
    rbPortfolioQrNone: "Geen QR",
    rbPortfolioQrPreview: "Zo verschijnt de QR-code",
    rbPortfolioQrPreviewBody: "Deze QR belandt linksonderaan de CV. Recruiters scannen en zien direct de publieke portfolio-pagina.",
    rbCoverItem: "Sluitstuk-pagina (optioneel)",
    rbCoverItemHelp: "Voeg één portfolio-project toe als extra pagina achterop je CV — met de eerste afbeelding als hero-visual.",
    rbCoverItemNone: "Geen sluitstuk",
    rbCoverItemEmpty: "Voeg eerst een project toe aan dit portfolio om het als sluitstuk te kunnen kiezen.",
    rbRefPreviewEyebrow: "Zo verschijnt het op de PDF",
    rbRefPreviewDefault: "Referenties op aanvraag",

    // PopoutTextarea — klik-om-groter-te-bewerken editor.
    popoutTitle: "Bewerken",
    popoutExpand: "Vergroot editor",
    popoutSave: "Opslaan",
    popoutCancel: "Annuleren",
    popoutSaved: "Opgeslagen",
    popoutShortcut: "⌘/Ctrl + Enter = opslaan",
    popoutChars: "{n} tekens",
    rbRole: "Functietitel",
    rbCompany: "Bedrijf",
    rbLocation: "Plaats",
    rbFrom: "Van",
    rbUntil: "Tot",
    rbCurrentRole: "Heden (loopt nog)",
    rbDescriptionLabel: "Omschrijving",
    rbAchievementsLabel: "Behaalde resultaten",
    rbAchievementsHint: "Concrete uitkomsten van deze rol. Eén per regel, elke regel begint met '•'. Verschijnt op je CV-PDF onder de rol-omschrijving.",
    rbAchievementsPh: "• Leidde een team van 8 developers naar succesvolle oplevering van…\n• Verlaagde infrastructuurkosten met 30% door…",
    rbAchievementsSuggestCta: "AI voorstel",
    rbAchievementsPolishCta: "AI herschrijf",
    rbAchievementsBusy: "AI denkt…",
    rbAchievementsSuggestHint: "AI stelt 3-5 concrete resultaten voor op basis van deze rol + omschrijving. Voorstellen gebruiken uitsluitend feiten die al in je omschrijving staan.",
    rbAchievementsSuggestNeedsDesc: "Vul eerst functietitel + omschrijving in — dan kan de AI resultaten voorstellen.",
    rbAchievementsPolishHint: "AI herschrijft jouw huidige tekst naar STAR-bullets zonder feiten te veranderen.",
    rbAchievementsPolishNeedsText: "Voeg eerst tekst toe — dan kan de AI die polijsten.",
    rbAchievementsSuggestDone: "AI heeft resultaten voorgesteld — pas aan waar je wilt.",
    rbAchievementsPolishDone: "Tekst gepolijst.",
    rbAchievementsUndo: "Ongedaan maken",
    rbAchievementsFail: "AI-actie mislukt — probeer opnieuw.",
    rbAchievementsHintTitle: "Waarom achievements je match-score verhogen",
    rbAchievementsHintBody: "Beschrijvingen tonen wát je deed. Behaalde resultaten tonen wat het opleverde — concreet en meetbaar. Recruiters en AI-match-scores wegen resultaten zwaarder dan taken.",
    rbAchievementsHintExOldLabel: "Alleen omschrijving:",
    rbAchievementsHintExOld: "Ik was verantwoordelijk voor cloud-migratie.",
    rbAchievementsHintExNewLabel: "+ Met resultaat:",
    rbAchievementsHintExNew: "Leidde de cloud-migratie van 12 legacy-systemen naar AWS binnen 6 maanden en verlaagde infrastructuurkosten met 30%.",
    rbAchievementsHintFooter: "Tip: laat 'AI voorstel' 3-5 bullets uit je huidige omschrijving destilleren, en polijst ze daarna met 'AI herschrijf'. Blijft leeg als je het veld niet gebruikt — geen kop op je CV-PDF.",
    rbNoPeriod: "Periode onbekend",

    // Wizards
    wizExpTitleAdd: "Ervaring-wizard",
    wizExpTitleOptimize: "AI-suggestie voor deze ervaring",
    wizStep1: "Stap 1 · Wanneer en waar",
    wizStep2: "Stap 2 · Wat deed je?",
    wizStep3: "Stap 3 · AI-voorstel",
    wizWhatLabel: "Wat deed je daar?",
    wizWhatPh: "Beschrijf in je eigen woorden wat je deed, je verantwoordelijkheden en resultaten…",
    wizNext: "Volgende",
    wizBack: "Terug",
    wizGenerate: "Genereer voorstel",
    wizGenerating: "AI schrijft… (10-30 sec)",
    wizRegenerate: "Opnieuw genereren",
    wizProposalHint: "Pas de tekst aan of behoud hem zoals hij is.",
    wizProposalPlaceholder: "Hier verschijnt zo direct het AI-voorstel — je kunt het daarna nog aanpassen…",
    wizEmptyResult: "De AI heeft geen tekst kunnen genereren",
    wizEmptyResultHelp: "Dit kan gebeuren als je vragen te kort waren of als het model tijdelijk niet reageert. Klik op 'Opnieuw genereren' om een nieuw voorstel op te halen.",
    wizKeepSave: "Behouden & opslaan",
    wizFailed: "Genereren mislukt — probeer opnieuw",
    wizExpRequired: "Bedrijf en functietitel zijn verplicht",
    wizWhatRequired: "Beschrijf eerst wat je deed",
    wizProfileTitle: "Profiel-wizard",
    wizProfileMode: "Hoe wil je het profiel opbouwen?",
    wizProfileFromExp: "Op basis van mijn werkervaringen",
    wizProfileFromExpHint: "AI destilleert de rode draad uit je ervaringen",
    wizProfileQuestions: "Via een paar vragen",
    wizProfileQuestionsHint: "Wie ben je, persoonlijkheid en vaardigheden",
    wizWho: "Wie ben je professioneel?",
    wizWhoPh: "bv. Ervaren projectleider met hart voor mensen en processen…",
    wizPersonality: "Persoonlijkheid",
    wizPersonalityPh: "bv. betrouwbaar, communicatief, resultaatgericht…",
    wizSkillsQ: "Belangrijkste vaardigheden",
    wizSkillsQPh: "bv. stakeholdermanagement, Agile, verandertrajecten…",
    wizNoExperiences: "Nog geen werkervaringen — kies de vragen-route",
    wizAnswerOne: "Beantwoord minstens één vraag",

    // Letters
    ltTitle: "Motivatiebrieven",
    ltSubtitle: "Brief + eisen-validatie, gegenereerd op basis van een opgeslagen CV",
    ltNew: "Nieuwe brief",
    ltEmpty: "Nog geen brieven. Start de wizard om je eerste motivatiebrief te genereren.",
    ltConfirmDelete: "Deze brief verwijderen?",
    ltDeleted: "Brief verwijderd",
    ltLoadFailed: "Brieven laden mislukt",
    ltRetention: "Bewaartermijn",
    ltRetentionHint: "Brieven ouder dan deze termijn worden automatisch verwijderd",
    ltRetention30: "30 dagen",
    ltRetention90: "90 dagen (standaard)",
    ltRetention180: "180 dagen",
    ltRetention365: "1 jaar",
    ltRetentionForever: "Voor altijd",
    ltRetentionSaved: "Bewaartermijn opgeslagen",
    ltBasedOn: "Op basis van",
    ltCreatedAt: "Aangemaakt",
    ltOpen: "Openen",
    ltInRegisterBadge: "In overzicht",
    ltInRegisterHint: "Deze brief is gekoppeld aan een sollicitatie — klik om de sollicitatie te openen",
    ltMatchScore: "Match-score",
    ltMatchScoreHint: "AI-schatting van hoe goed jouw CV bij deze vacature past — hard requirements ~50%, taken ~30%, soft skills ~20%.",
    mseTrigger: "Hoe wordt deze score berekend?",
    mseTitle: "Hoe werkt de match-score?",
    mseIntro: "De AI vergelijkt jouw CV met de vacature en geeft een score van 0–100. Onder de motorkap wegen we drie onderdelen mee:",
    mseWeightingTitle: "Weging",
    mseWeightMust: "Hard requirements — must-haves uit de vacature",
    mseWeightTasks: "Taken & verantwoordelijkheden",
    mseWeightSoft: "Soft skills & nice-to-haves",
    mseBandsTitle: "Wat betekent mijn score?",
    mseBand90: "Volledige match op vrijwel alle eisen — direct sollicitatie-klaar.",
    mseBand75: "Sterke fit met kleine gaps — vaak goed genoeg voor uitnodiging.",
    mseBand60: "Redelijke fit, meerdere gaps — Match-verbeter Wizard raadzaam.",
    mseBand40: "Zwakke fit — overweeg een CV-variant beter afgestemd op deze rol.",
    mseBandLow: "Slechte fit — vacature past waarschijnlijk niet bij jouw profiel.",
    mseDisclaimer: "AI-inschatting op basis van tekstanalyse. Geen garantie op uitnodiging — recruiters kijken ook naar zaken buiten het CV om (motivatie, referenties, timing).",
    mseCtaWizard: "Start Match-verbeter Wizard",
    mseCtaChooseCv: "Overweeg een andere CV-variant",
    mseCtaChooseCvHint: "Open 'Mijn CV's' in het menu links en kies een variant die dichter bij deze vacature aansluit — of maak een nieuwe.",
    mseCtaChooseCvBtn: "Bekijk mijn CV-varianten",
    mseNavToastTitle: "Kies een CV-variant voor «{job}»",
    mseNavToastFallback: "Zoek een variant met meer overlap met de vacature-eisen.",
    pjhTitle: "Ontbreekt de juiste variant voor «{job}»?",
    pjhOpenBuilder: "Open de CV-Generator",
    pjhDismiss: "Sluit deze tip",
    pjhGenerate: "Genereer AI-variant nu",
    pjhGenerating: "AI schrijft…",
    pjhGenerated: "Nieuwe variant «{name}» aangemaakt — open om te bewerken.",
    pjhGenerateFailed: "AI kon de variant niet aanmaken — probeer opnieuw.",
    aiInfoTitle: "Deze variant is door AI afgestemd op de vacature «{job}»",
    aiInfoSubtitle: "AI heeft {n} tekstsecties herschreven op basis van jouw bestaande CV. Elke wijziging wordt onderbouwd met verbatim bewijs uit jouw eigen CV — geen verzonnen ervaring.",
    aiInfoShow: "Bekijk de wijzigingen",
    aiInfoHide: "Verberg de wijzigingen",
    aiInfoDismiss: "Sluit dit uitlegpaneel",
    aiInfoProfileLabel: "Profiel",
    aiInfoExperience: "Werkervaring",
    aiInfoBefore: "Origineel",
    aiInfoAfter: "AI-herschrijving",
    aiInfoGrounded: "Bewijs uit jouw CV",
    aiInfoRevert: "Herstel origineel",
    aiInfoRevertHint: "Zet deze sectie terug naar de originele tekst uit je bron-CV",
    aiInfoReverted: "Sectie hersteld naar origineel — vergeet niet op te slaan",
    mseCtaCongrats: "Deze brief is klaar voor verzending — je CV dekt de vacature bijna volledig. Succes!",
    ltImproveCta: "Verbeter deze match",
    ltImproveBadge: "Verbeter",
    ltImproveUsage: "Nog {r} van {l} Match-AI acties over deze maand",
    ltImproveTitle: "Match-advies",
    ltImproveSubtitle: "Concrete stappen om jouw score te verhogen",
    ltImproveLoading: "AI analyseert jouw CV tegen de vacature…",
    ltImproveFailed: "Advies genereren mislukt — probeer opnieuw",
    ltImproveNow: "Nu",
    ltImproveProjected: "Potentieel",
    ltImproveImpactUnit: "punten",
    ltImproveImpactHint: "Geschatte extra match-punten als je deze tip toepast",
    ltImproveDisclaimer: "AI-suggesties op basis van jouw CV en de vacature — kritisch beoordelen blijft aan jou.",
    ltImproveCat_skills: "Vaardigheden",
    ltImproveCat_experience: "Ervaring",
    ltImproveCat_wording: "Formulering",
    ltImproveCat_learning: "Leerroute",
    ltRewriteCta: "Herschrijf CV",
    ltRewriteCtaTitle: "Laat AI je CV bijwerken",
    ltRewriteCtaHint: "Op basis van bovenstaande wording- en ervaring-tips genereert de AI een voorstel — jij bekijkt het naast je huidige tekst en accepteert of verwerpt.",
    ltRewriteTitle: "Voorgestelde CV-tekst",
    ltRewriteSubtitle: "Bekijk voor je accepteert",
    ltRewriteHint: "Alleen profieltekst en werkervaring-beschrijvingen worden herschreven — feiten, data en functies blijven ongewijzigd.",
    ltRewriteLoading: "AI stelt tekstverbeteringen voor…",
    ltRewriteFailed: "Herschrijving genereren mislukt — probeer opnieuw",
    ltRewriteApplyFailed: "Toepassen mislukt — je CV is niet gewijzigd",
    ltRewriteApplied: "CV bijgewerkt met AI-advies",
    ltRewriteAppliedFork: "Nieuwe CV-variant aangemaakt: {name}",
    ltRewriteFork: "Nieuwe variant",
    ltDetachTitle: "Deze brief gebruikt je standaard-CV",
    ltDetachBody: "Elke wijziging aan “{name}” (handmatig of via AI voor andere vacatures) verandert nu direct wat je bij deze brief downloadt. Ontkoppel om een aparte variant vast te leggen — je standaard-CV blijft dan onaangeraakt.",
    ltDetachCta: "Ontkoppel",
    ltEnrichTitle: "Verrijk deze brief",
    ltEnrichHint: "Voeg extra info toe (bijv. een project of achievement) — de AI verwerkt dit in een nieuwe versie van de brief én de eisen-validatie.",
    ltEnrichPlaceholder: "Bijv. 'Ik heb ook 2 jaar Kubernetes-ervaring opgedaan bij X' of 'benadruk mijn stakeholder-management'…",
    ltEnrichCta: "Verwerk & hergenereer",
    ltEnrichBusy: "Bezig met verwerken…",
    ltEnrichSuccess: "Nieuwe versie van de brief gegenereerd",
    ltEnrichFailed: "Kon brief niet hergenereren — probeer opnieuw",
    ltEnrichPreviewEyebrow: "Nieuwe versie",
    ltEnrichPreviewTitle: "Bevestig de nieuwe brief",
    ltEnrichPreviewCurrent: "Huidige versie",
    ltEnrichPreviewNew: "AI-gegenereerde versie",
    ltEnrichPreviewApply: "Toepassen",
    ltEnrichPreviewReject: "Annuleren",
    ltEnrichPreviewFooterHint: "Bij Toepassen wordt de brief bijgewerkt en de PDF opnieuw aangemaakt.",
    ltEnrichPreviewEditHint: "Je kunt de nieuwe versie handmatig bewerken voor toepassen.",
    ltEnrichPreviewEditedBadge: "Handmatig aangepast",
    ltDetachBusy: "Ontkoppelen…",
    ltDetachConfirm: "Aparte CV-variant maken voor deze vacature? Je standaard-CV blijft ongewijzigd.",
    ltDetachSuccess: "Losse variant aangemaakt: {name}",
    ltDetachFailed: "Ontkoppelen mislukt",
    ltRewriteAccept: "Toepassen op CV",
    ltRewriteApplying: "Toepassen…",
    ltRewriteReject: "Verwerpen",
    ltRewriteBefore: "Huidige tekst",
    ltRewriteAfter: "Nieuwe tekst",
    ltRewriteProfileLabel: "Profieltekst",
    ltRewriteExpLabel: "Werkervaring",
    ltRewriteEmpty: "Geen tekstverbeteringen gevonden — het advies bevat vooral leerroutes of vaardigheden.",
    ltRewriteSourcesCta: "Bronnen",
    ltRewriteSourcesTitle: "Gebaseerd op uit je CV",
    ltRewriteSourcesHint: "Toon de exacte CV-regels waarop deze herschrijving is gebaseerd",
    ltRewriteCompensatesLabel: "Compenseert",
    ltRewriteCompensatesHint: "Deze ervaring dekt aantoonbaar deze eis uit de vacature",
    ltRewriteEditCta: "Bewerken",
    ltRewriteEditHint: "Neem het voorstel over en pas het aan naar jouw stijl",
    ltRewriteEditSave: "Opslaan",
    ltRewriteEditCancel: "Annuleren",
    ltRewriteEditedLabel: "Aangepast",
    ltRewriteEditedHint: "Deze tekst is bijgewerkt t.o.v. het AI-voorstel",
    ltRewriteResetCta: "Herstel origineel",
    ltRewriteResetHint: "Zet de tekst terug naar het originele AI-voorstel",
    ltRewriteTitleSwapEyebrow: "Functietitel aangepast",
    ltRewriteTitleSwapAsk: "De titel in deze CV-variant wordt automatisch afgestemd op de vacature. Vink uit om de originele titel te behouden.",
    ltRewriteTitleSwapHint: "Alleen deze variant wordt aangepast — je originele standaard-CV blijft ongewijzigd.",
    ltTipContextCta: "Geef extra input op dit criterium",
    ltTipContextEdit: "Bewerk toelichting",
    ltTipContextTitle: "Extra toelichting",
    ltTipContextHint: "Wat weet je zelf dat de AI nog niet uit je CV kan halen? Bijvoorbeeld ervaring bij een specifieke klant of een resultaat dat je niet hebt vermeld.",
    ltTipContextClose: "Sluiten",
    ltTipContextPh: "Vertel wat je precies hebt gedaan, of tik op de microfoon om in te spreken…",
    ltTipContextMicStart: "Spraak-naar-tekst starten",
    ltTipContextMicStop: "Spraak-naar-tekst stoppen",
    ltTipContextMicRecording: "🔴 Aan het luisteren…",
    ltTipContextExpLabel: "Bij welke werkervaring hoort dit? (multi-select — selecteren alléén is genoeg; AI verwerkt deze eis dan uitsluitend in de omschrijvingen van de geselecteerde werkervaringen)",
    ltTipContextBadge: "Toelichting",
    ltTipContextBadgeHint: "Deze tip heeft extra input van jou die de AI meeneemt",
    ltTipEmployerBadge: "Van werkgever",
    ltTipEmployerBadgeHint: "Deze tip komt uit de verduidelijking die de werkgever vroeg. De AI verwerkt dit automatisch in je CV/brief.",
    ltMatchHistoryTitle: "Match-score verloop",
    ltRewriteTipScoresEyebrow: "Fit per criterium",
    ltRewriteTipScoresTitle: "Hoe goed dekt de herschreven CV nu elk criterium?",
    ltRewriteTipScoresContextNote: "{n} criterium/-a met jouw toelichting — de after-score verwerkt die input.",
    ltRewriteTipScoresContextChipHint: "Deze criterium-fit is bijgesteld op basis van jouw toelichting",
    ltRewriteTipScoresAvgLabel: "Totale winst",
    ltRewriteTipScoresJumpHint: "Klik om naar de bijbehorende herschreven tekst te scrollen",
    ltImproveTipFallback: "Tip",

    // Improve-match wizard (nested flow: advice → rewrite → regenerate → result)
    imwTitle: "Match-verbeter wizard",
    imwSubtitle: "Van advies naar hogere score in 4 stappen",
    imwStepAdvice: "Advies",
    imwStepRewrite: "CV herschrijven",
    imwStepRegen: "Nieuwe brief",
    imwStepResult: "Resultaat",
    imwBack: "Terug",
    imwGoRewrite: "Ga naar CV-herschrijven",
    imwApplyAndRegen: "Toepassen en brief hergenereren",
    imwFinish: "Klaar — sluit wizard",
    imwRollbackCta: "Terugdraaien",
    imwRollbackBusy: "Bezig met terugdraaien…",
    imwRollbackHint: "Herstel je originele CV én brief zoals ze waren vóór deze verbeter-ronde. De tijdelijke variant wordt verwijderd.",
    imwRollbackDone: "Terug op je oorspronkelijke CV en brief.",
    imwRollbackNoop: "Er was niets meer om terug te draaien.",
    imwRollbackFailed: "Terugdraaien mislukt — probeer opnieuw of open de brief later opnieuw.",
    imwKeepAnywayCta: "Toch doorvoeren",
    imwKeepAnywayHint: "Behoud de nieuwe versie ondanks de lagere match-score. Je kunt later handmatig verder finetunen.",
    imwResultDroppedEyebrow: "Let op — score daalde",
    imwResultDroppedTitle: "Je match-score zakte met {delta} punten",
    imwResultDroppedBody: "De AI-herschrijving heeft de match-score verlaagd in plaats van verhoogd. Kies of je toch doorgaat met de nieuwe versie of terugdraait naar je originele CV en brief.",
    imwNoRewriteTips: "Deze ronde levert geen wording- of ervaring-tips op om je CV aan te passen",
    imwRegenLoading: "AI schrijft een frisse motivatiebrief én rekent de match-score opnieuw uit…",
    imwRegenPending: "Klaar om te starten",
    imwRegenPatience: "Dit duurt meestal 30-60 seconden. Even geduld — we werken je brief live bij.",
    imwRegenOvertime: "Duurt langer dan verwacht…",
    imwRegenFailed: "Hergenereren mislukt — probeer opnieuw",
    imwResultBefore: "Voor",
    imwResultAfter: "Na",
    imwResultDelta: "punten",
    imwResultLetterPreview: "Voorproefje nieuwe brief",
    imwPurpose_advice_title: "Wat gebeurt hier?",
    imwPurpose_advice_body: "De AI vergelijkt jouw CV met de vacature en levert 4-6 concrete tips met een geschatte impact per tip. Dit is puur analyse — er wordt nog niets aan je CV of brief gewijzigd.",
    imwPurpose_rewrite_title: "Wat gebeurt hier?",
    imwPurpose_rewrite_body: "De AI stelt tekst-verbeteringen voor je profiel en werkervaring-beschrijvingen voor. Alleen wording verandert; feiten, datums en functietitels blijven exact zoals ze zijn. Je bekijkt eerst het voorstel voordat er iets wordt opgeslagen.",
    imwPurpose_regenerate_title: "Wat gebeurt hier?",
    imwPurpose_regenerate_body: "Je CV is nu bijgewerkt. De AI schrijft op basis daarvan een verse motivatiebrief én rekent de match-score opnieuw uit. Zo weet je meteen hoeveel je score gestegen is.",
    imwPurpose_result_title: "Wat gebeurt hier?",
    imwPurpose_result_body: "Vergelijk je oude en nieuwe match-score, lees de nieuwe samenvatting en bekijk het voorproefje van de brief. Je kunt de wizard nu sluiten — de bijgewerkte brief en CV zijn opgeslagen.",

    ltwTitle: "Motivatiebrief-wizard",
    ltwStepLabel: "Stap {n} van 5",
    ltwStep1: "De vacature",
    ltwStep2: "Kies je CV",
    ltwStep3: "Taal",
    ltwStep4: "Ervaringen uitlichten",
    ltwStep5: "Vaardigheden uitlichten",
    ltwUrl: "Vacature-URL",
    ltwScrape: "Ophalen",
    ltwScraping: "Ophalen…",
    ltwScrapeOk: "Vacature opgehaald",
    ltwScrapeFailed: "Ophalen mislukt — plak de tekst hieronder",
    ltwJobTitle: "Functietitel *",
    ltwCompany: "Bedrijf *",
    ltwDescription: "Vacaturetekst",
    ltwDescriptionPh: "Plak hier de vacaturetekst als ophalen niet lukt…",
    ltwPickResume: "Welk CV moet de brief volgen?",
    ltwNoResumes: "Nog geen CV-varianten — maak er eerst een in de CV Generator.",
    ltwLang: "In welke taal moet de brief geschreven worden?",
    ltwLangNl: "Nederlands",
    ltwLangEn: "Engels",
    ltwLangDe: "Duits",
    ltwLangFr: "Frans",
    ltwLangEs: "Spaans",
    ltwLangDetecting: "Taal van de vacature wordt automatisch gedetecteerd…",
    ltwLangAutoDetected: "Automatisch gedetecteerd op basis van de vacaturetekst — je kunt de taal altijd zelf wijzigen.",
    ltwHighlightExp: "Wil je bepaalde ervaringen EXTRA uitlichten? Selecteer ze.",
    ltwHighlightSkills: "Welke vaardigheden wil je benadrukken?",
    ltwOptional: "Optioneel — niets selecteren mag ook",
    ltwNoItems: "Geen items gevonden in deze CV-variant.",
    ltwGenerate: "Genereer brief + validatie",
    ltwGenerating: "AI schrijft je brief… (30-60 sec)",
    ltwElapsed: "{s} sec verstreken",
    ltwStageLetter: "1. Brief opstellen",
    ltwStageValidation: "2. Eisen valideren",
    ltwStageScore: "3. Match-score",
    ltwTimeoutEyebrow: "AI reageert wat traag",
    ltwTimeoutBody: "De AI-server nam net iets langer dan onze randservers wilden wachten. Je invoer is bewaard — klik op Opnieuw proberen om het meteen nog eens te versturen.",
    ltwTimeoutRetry: "Opnieuw proberen",
    ltwAutoRetry: "AI-server was traag — opnieuw versturen…",
    ltwDraftRestored: "Concept van je vorige sessie hersteld",
    ltwDraftClear: "Wissen & opnieuw",
    ltwRequired: "Functietitel en bedrijf zijn verplicht",
    ltwPickResumeFirst: "Kies eerst een CV-variant",
    ltwGenerated: "Brief gegenereerd",
    ltwFailed: "Genereren mislukt — probeer opnieuw",

    ltLetter: "Motivatiebrief",
    ltLetterHint: "Maximaal 1 A4 — pas de tekst gerust aan",
    ltValidation: "Eisen-validatie",
    ltMaximize: "Schermvullend",
    ltMinimize: "Venster verkleinen",
    prepDossier: "Gebruikt bij deze sollicitatie",
    prepDossierCv: "CV-variant",
    prepDossierLetter: "Motivatiebrief",
    prepDossierCvGone: "variant verwijderd",
    prepDossierNone: "Nog geen motivatiebrief gekoppeld aan deze sollicitatie.",
    prepDlCv: "CV (PDF)",
    prepDlLetter: "Brief (PDF)",
    prepDlPackage: "Pakket (PDF)",
    dashNoResponse: "{days} dgn geen reactie",
    dashFollowedUp: "Opgevolgd · wacht op reactie",
    emwFollowedUpMarked: "Opvolging geregistreerd bij de sollicitatie",
    ltValidationHint: "Per eis uit de vacature, in de ik-vorm",
    ltValTitlePh: "Eis of wens…",
    ltAddValItem: "Item toevoegen",
    ltSaved: "Brief opgeslagen",
    ltSaveFailed: "Opslaan mislukt",
    ltDownloads: "Downloads",
    ltDlLangLabel: "Taal",
    ltDlLangTranslateNotice: "Brief wordt automatisch vertaald van {from} → {to} (kosteloos gecached voor volgende downloads).",
    ltDlPackageZip: "Beide talen (ZIP)",
    ltDlPackageZipTitle: "Download het sollicitatiepakket in NL én EN in één ZIP-bestand.",
    ltDlLangEditTranslation: "Vertaling bewerken",
    trEdEyebrow: "Vertaling bewerken",
    trEdTitle: "Verfijn de vertaling · {source} → {target}",
    trEdSourceLabel: "Origineel",
    trEdTargetLabel: "Vertaling (aanpasbaar)",
    trEdSameLangHint: "Bewerk je hier de bron-tekst — deze wordt direct opgeslagen als de brief-inhoud.",
    trEdCachedHint: "Deze vertaling was al eerder gegenereerd. Pas 'm hier aan en sla op om de download-versie te bevriezen.",
    trEdFreshHint: "Vers gegenereerd door AI — controleer op fouten en pas gerust aan. Sla op om de download-versie te bevriezen.",
    trEdFooterHint: "Opslaan overschrijft de {target}-versie in downloads en het sollicitatiepakket.",
    trEdSaveCta: "Opslaan",
    trEdSaving: "Opslaan…",
    trEdCancel: "Annuleren",
    trEdLoading: "Vertaling laden…",
    trEdLoadFail: "Vertaling laden mislukt",
    trEdSaveFail: "Opslaan mislukt",
    trEdSaved: "Vertaling opgeslagen",
    trEdEmpty: "Vertaling mag niet leeg zijn",
    ltDlResume: "1 · CV (PDF)",
    ltDlValidation: "2 · Eisen-validatie (PDF)",
    ltDlLetter: "3 · Motivatiebrief (PDF)",
    ltDlBusy: "Bezig…",
    ltOpenVacancy: "Open vacaturepagina",
    ltOpenVacancyHint: "Direct naar de vacaturepagina om je CV en motivatiebrief te uploaden bij de aanbieder",
    ltValPolishCta: "Herschrijf naar goedlopende argumentatie",
    ltValPolishHint: "AI polijst je tekst zonder feiten te veranderen",
    ltValPolishTooShort: "Tekst te kort — schrijf minstens één zin voordat je AI vraagt te polijsten.",
    ltValPolishNoChange: "AI vond geen verbetering — je tekst leest al soepel.",
    ltValPolishDone: "Tekst herschreven",
    ltValPolishUndo: "Ongedaan maken",
    ltValPolishFail: "AI-herschrijving mislukt — probeer opnieuw.",
    ltValPolishBulkCta: "Polijst alle eisen",
    ltValPolishBulkHint: "AI herschrijft alle validatie-items tegelijk naar vloeiende argumentatie, zonder feiten te veranderen.",
    ltValPolishBulkBusy: "AI polijst alle items…",
    ltValPolishBulkDone: "{n} validatie-items herschreven",
    ltValPolishBulkNoChange: "AI vond geen verbeteringen — je items lezen al soepel.",
    ltValPolishBulkFail: "Bulk-polijsten mislukt — probeer opnieuw.",
    ltValRegenCta: "Herbereken",
    ltValRegenBusy: "AI analyseert eisen…",
    ltValRegenHint: "Genereer de eisen-validatie opnieuw tegen de gekoppelde CV. Kies diepgang in het menu.",
    ltValRegenNoCv: "Geen CV gekoppeld — koppel eerst een CV om de validatie te (her)berekenen.",
    ltValRegenDeepLabel: "Uitgebreid (per ervaring)",
    ltValRegenDeepHint: "AI zoekt door alle werkervaringen en benoemt per eis élk bedrijf + periode + concreet voorbeeld. Beste voor krachtige argumentatie.",
    ltValRegenConciseLabel: "Beknopt (1-2 zinnen)",
    ltValRegenConciseHint: "Klassieke stijl: 1-2 zinnen per eis. Sneller te scannen, minder detail.",
    ltValRegenDone: "{n} validatie-items opnieuw gegenereerd",
    ltValRegenFail: "Herberekenen mislukt — probeer opnieuw.",
    ltValCompareEyebrow: "Vergelijken",
    ltValCompareTitle: "Vergelijk oude vs nieuwe eisen-validatie",
    ltValCompareBody: "Kies per eis of je de nieuwe versie (rechts) overneemt, de oude behoudt (links), of de nieuwe eerst even bijschaaft in het tekstveld. Standaard: alles wat de AI verbeterde is aangevinkt.",
    ltValCompareColOld: "Oud (huidig)",
    ltValCompareColNew: "Nieuw (AI-voorstel)",
    ltValCompareAcceptAll: "Alle nieuwe overnemen",
    ltValCompareKeepAll: "Alles behouden",
    ltValCompareStats: "{acc} overnemen · {keep} behouden · {drop} verwijderd",
    ltValCompareUnchanged: "AI liet dit item ongewijzigd.",
    ltValCompareOldEmptyNetNew: "Nieuw item — dit stond er nog niet.",
    ltValCompareNewEmpty: "—",
    ltValCompareAiDropped: "AI heeft dit item weggelaten",
    ltValCompareKeepThis: "Oude behouden",
    ltValCompareTakeNew: "Nieuwe overnemen",
    ltValCompareApply: "Toepassen",
    ltValCompareApplied: "{n} validatie-items bijgewerkt",
    ltValCompareApplyFail: "Opslaan mislukt — probeer opnieuw.",
    ltDlOverlayResume: "CV downloaden…",
    ltDlOverlayLetter: "Motivatiebrief downloaden…",
    ltDlOverlayValidation: "Eisen-validatie downloaden…",
    ltDlOverlayPackage: "Sollicitatiepakket samenstellen…",
    ltDlOverlayPackageZip: "Bilingual pakket samenstellen…",
    ltDlOverlayGeneric: "Bestand voorbereiden…",
    ltDlOverlayHint: "Even geduld — dit kan een paar seconden duren",
    ltDlResumeMissing: "De gekoppelde CV-variant bestaat niet meer",
    ltToRegister: "Zet in Sollicitatieoverzicht",
    ltToRegisterHint: "Voegt deze sollicitatie toe aan je Sollicitatieoverzicht voor de volgende stappen",
    ltInRegister: "Staat in Sollicitatieoverzicht ✓",
    ltToRegisterOk: "Toegevoegd aan Sollicitatieoverzicht",
    ltToRegisterFailed: "Toevoegen mislukt",
    dashLetterButton: "Motivatiebrief",

    // Sidebar navigation + new job wizard
    navOverview: "Overzicht",
    navMyCvs: "Mijn CV's",
    navMyLetters: "Mijn Motivatiebrieven",
    navBookmarks: "Favoriete sites",
    navReferences: "Referenties",
    // References panel
    refsTitle: "Referenties",
    refsHeading: "Beheer je referenties",
    refsSubtitle: "Beheer wie je opgeeft als referentie. Vraag hen akkoord via e-mail en kies zelf welke gegevens gedeeld worden. Op je publieke CV staat altijd alleen 'Referenties op aanvraag'.",
    refsAddTitle: "Nieuwe referentie",
    refsFieldName: "Naam",
    refsFieldEmail: "E-mailadres",
    refsFieldPhone: "Telefoonnummer",
    refsFieldRelationship: "Relatie (hoe je elkaar kent)",
    refsFieldLanguage: "Taal e-mail",
    refsColLanguage: "Taal",
    refsAddCta: "Toevoegen",
    refsFieldsRequired: "Naam en e-mail zijn verplicht",
    refsAdded: "Referentie toegevoegd",
    refsAddFailed: "Toevoegen mislukt",
    refsLoadFailed: "Referenties konden niet worden geladen",
    refsConfirmDelete: "Deze referentie verwijderen?",
    refsDeleteFailed: "Verwijderen mislukt",
    refsUpdateFailed: "Bijwerken mislukt",
    refsEmpty: "Nog geen referenties. Voeg er hierboven één toe.",
    refsColName: "Naam",
    refsColContact: "Contact",
    refsColRelationship: "Relatie",
    refsColStatus: "Status",
    refsColActions: "Acties",
    refsInviteCta: "Verzoek als referentie",
    refsInviteSent: "Verzoek verzonden",
    refsInviteFlashHint: "Deze referentie heeft nog geen uitnodiging — klik om te versturen",
    refsInviteNowTitle: "Meteen uitnodigen?",
    refsInviteNowBody: "Wil je deze referentie direct een uitnodigingsmail sturen? Zo hoef je er later niet aan te denken.",
    refsInviteNowYes: "Ja, verstuur nu",
    refsInviteNowNo: "Nee, later",
    refsInviteFailed: "Verzenden mislukt",
    refsInviteNoKey: "E-mail niet verstuurd — Resend niet geconfigureerd",
    refsPublicNote: "Op je publieke CV wordt geen enkele referentie getoond. Bezoekers zien altijd 'Referenties op aanvraag'. Alleen jij deelt de gegevens actief met een werkgever.",
    refStatusNoInvite: "Geen uitnodiging gestuurd",
    refStatusPending: "In afwachting",
    refStatusApproved: "Goedgekeurd",
    refStatusDeclined: "Afgewezen door referentie",
    refsWaCta: "Deel via WhatsApp",
    refsWaMessage: "Hoi, wil je mijn referentie zijn voor mijn nieuwe zoektocht? Vul kort je gegevens in via deze link — het duurt 1 minuut. {url}",
    refsWaOpened: "WhatsApp geopend — verstuur het bericht",
    refsWaFailed: "Kon deel-link niet aanmaken",
    refsPdfCta: "Download referentielijst",
    refsPdfTitle: "Referentielijst genereren",
    refsPdfTemplate: "Template (design)",
    refsPdfTemplateDefault: "Standaard (geen template)",
    refsPdfLanguage: "Taal van het document",
    refsPdfIntro: "Introtekst",
    refsPdfIntroDefault: "Hierbij mijn referenties voor de zoektocht naar een nieuwe uitdaging. Neem gerust rechtstreeks contact op — zij hebben allemaal ingestemd.",
    refsPdfSelect: "Welke referenties opnemen?",
    refsPdfNoApproved: "Nog geen goedgekeurde referenties.",
    refsPdfGenerate: "Genereren",
    refsPdfPickAtLeastOne: "Selecteer minstens één referentie",
    refsPdfDownloaded: "PDF gegenereerd",
    refsPdfFailed: "PDF genereren mislukt",
    njwCta: "Nieuwe baan gezien?",
    njwTitle: "Nieuwe baan",
    njwStep1: "Stap 1 · Waar zag je de vacature?",
    njwStep2: "Stap 2 · Controleer de gegevens",
    njwStep3: "Opgeslagen — wat wil je nu doen?",
    njwManual: "Geen URL? Vul handmatig in",
    njwViaCrawler: "Via Vacature Crawler",
    njwViaCrawlerHint: "Doorzoek LinkedIn, Indeed, Glassdoor en Adzuna in één keer — vind de vacature en voeg direct toe.",
    njwSaved: "Sollicitatie opgeslagen in het Sollicitatieoverzicht",
    njwActLetter: "Motivatiebrief maken",
    njwActPrep: "Interviewvoorbereiding",
    njwActDone: "Naar het overzicht",
    njwSave: "Opslaan in Sollicitatieoverzicht",

    // Admin emails
    admEmails: "E-mails",
    admEmailNote: "Zonder RESEND_API_KEY worden mails overgeslagen. Haal een key op via resend.com en voeg die toe aan de backend-configuratie.",
    admEmailKindWelcome: "Welkomstmail",
    admEmailKindReminder: "Proef-herinnering (2 dgn)",
    admEmailKindExpired: "Proef afgelopen",
    admEmailKindFollowup: "Follow-up digest",
    admEmailKindPackPurchased: "Pakket-welkomstmail",
    admEmailKindRebuyReminder: "Verleng-herinnering",
    admEmailKindAffiliatePayout: "Affiliate-uitbetaling",
    admEmailKindDormantPartner: "Dormant partner-nudge",
    admDormantEyebrow: "Dormant partner-nudge",
    admDormantTitle: "Vanaf hoeveel dagen inactief krijgen partners een reminder?",
    admDormantHelp: "Affiliates die deze drempel + geen invite verstuurd én geen conversie in dat venster hebben, krijgen wekelijks een korte reactivatie-mail. Aanbevolen: 30 dagen. Minder aggressief: 45. Meer aggressief: 14.",
    admDormantUnit: "dagen",
    admDormantSave: "Opslaan",
    admDormantSaved: "Drempel opgeslagen",
    admDormantSaveFailed: "Opslaan mislukt",
    admEmailTestHint: "Stuur een test naar je eigen adres:",
    admEmailSent: "Testmail verstuurd",
    admEmailEmpty: "Nog geen e-mails verstuurd.",
    admEmailColKind: "Type",

    // New CV wizard
    rbEditExisting: "Bewerk bestaande CV",
    rbNewCv: "Nieuwe CV maken",
    ncwTitle: "Nieuwe CV-wizard",
    ncwCta: "Nieuwe CV",
    rbSecHobbies: "Hobby's",
    rbHobbyPh: "bv. Hardlopen",
    rbSkillLevelHint: "Klik op de punten voor een niveau 1 t/m 5 (5 = excellent) — handig voor bijv. talen. Nogmaals klikken op hetzelfde punt wist het niveau.",
    rbDefault: "Standaard",
    rbMakeDefault: "Maak standaard",
    rbDefaultSet: "Standaard-CV bijgewerkt",
    rbSecTemplate: "Template designer",
    rbTemplateHint: "Stel je eigen CV-stijl samen — kies een voorbeeldstijl of ontwerp zelf, en bekijk direct het voorbeeld",
    rbTplPresets: "Voorbeeldstijlen",
    rbTplLayout: "Indeling",
    rbTplLayoutLeft: "Zijbalk links",
    rbTplLayoutRight: "Zijbalk rechts",
    rbTplLayoutSingle: "Eén kolom",
    rbTplAccent: "Accentkleur",
    rbTplAccentCustom: "Eigen kleur",
    rbTplFont: "Lettertype",
    rbTplFontModern: "Modern (schreefloos)",
    rbTplFontClassic: "Klassiek (serif)",
    rbTplDensity: "Dichtheid",
    rbTplDenseCompact: "Compact",
    rbTplDenseNormal: "Normaal",
    rbTplDenseAiry: "Luchtig",
    rbTplOptions: "Opties",
    rbTplSideBg: "Getinte zijbalk",
    rbTplHeaderCenter: "Naam gecentreerd",
    rbTplRateSkills: "Rating bij vaardigheden",
    rbTplRateLanguages: "Rating bij talen",
    rbTplSkillBullets: "Opsommingsteken voor vaardigheden",
    rbTplSkillBulletNone: "Geen",
    rbTplSkillBulletDot: "Bolletje",
    rbTplSkillBulletSquare: "Vierkant",
    rbTplSkillBulletDash: "Streep",
    rbTplSkillBulletArrow: "Pijl",
    rbTplFontMono: "Typemachine (mono)",
    rbTplPhoto: "Foto",
    rbTplShowPhoto: "Foto tonen",
    rbTplShape_square: "Vierkant",
    rbTplShape_rounded: "Afgerond",
    rbTplShape_circle: "Cirkel",
    rbTplPhotoHint: "Sleep de sectie ‘Foto’ naar de gewenste plek · uploaden via Jouw profiel",
    rbTplBgTitle: "Achtergrondafbeelding",
    rbTplBgHint: "Vult de hele A4-pagina van het CV op elke pagina.",
    rbTplBgUpload: "Achtergrond uploaden",
    rbTplBgReplace: "Vervangen",
    rbTplBgRemove: "Verwijderen",
    rbTplBgOpacity: "Doorschijnendheid",
    rbTplBgOpacityHint: "0% = onzichtbaar, 100% = volledig gevuld. Meestal werkt 10–25% het beste voor leesbaarheid.",
    rbTplBgFormats: "PNG, JPG of WEBP · max 4 MB",
    rbTplBgPresetsTitle: "Standaard achtergronden",
    rbTplBgPresetPaper: "Papier",
    rbTplBgPresetGrid: "Raster",
    rbTplBgPresetDots: "Stippen",
    rbTplBgPresetGradient: "Gradient",
    rbTplBgPresetSunset: "Sunset",
    rbTplBgPresetOcean: "Oceaan",
    rbTplBgPresetMint: "Mint",
    rbTplBgPresetSand: "Zand",
    rbTplBgPresetLavender: "Lavendel",
    rbTplBgPresetLines: "Lijnen",
    rbTplBgPresetWaves: "Golven",
    rbTplBgPresetAccentLeft: "Zijbalk",
    rbTplBgPresetHex: "Honingraat",
    rbTplBgMyPresetsTitle: "Jouw achtergronden",
    rbTplBgSavePreset: "Opslaan als preset",
    rbTplBgSavePrompt: "Geef deze achtergrond een naam:",
    rbTplBgSaveDefaultName: "Mijn achtergrond",
    rbTplBgSaved: "Achtergrond opgeslagen",
    rbTplBgSaveFailed: "Opslaan mislukt",
    rbTplSections: "Indeling van secties",
    rbTplSectionsHint: "Sleep secties tussen de header, zijbalk en hoofdkolom, of wijzig de volgorde",
    rbTplSectionsHintSingle: "Eén kolom: sleep om de volgorde te bepalen (bovenste zone komt eerst)",
    rbTplZoneSide: "Zijbalk",
    rbTplZoneMain: "Hoofdkolom",
    rbTplZoneTop: "Bovenaan",
    rbTplZoneBottom: "Daarna",
    rbDndLanguages: "Talen",
    rbTplSavedTitle: "Opgeslagen sjablonen",
    rbTplNamePh: "bv. Mijn zakelijke stijl",
    rbTplSaveBtn: "Sjabloon opslaan",
    rbTplNameRequired: "Geef het sjabloon eerst een naam",
    rbTplSaved: "Sjabloon opgeslagen",
    rbTplApply: "Gebruik",
    rbTplApplied: "Sjabloon toegepast op dit CV",
    rbTplPickHint: "Kies een stijl voor dit CV — eigen templates maak en beheer je onder ‘Mijn templates’ in het menu",
    rbTplManageHint: "Templates maken of bewerken? Ga naar ‘Mijn templates’ in het menu",
    navTemplates: "Mijn templates",
    tmSubtitle: "Jouw CV- en briefstijlen",
    tmHint: "Ontwerp een template en kies deze bij het maken van een CV of motivatiebrief",
    tmNewBtn: "Nieuw template",
    tmEmptyTitle: "Nog geen templates",
    tmEmptyHint: "Maak je eerste template en gebruik deze straks voor je CV en motivatiebrief.",
    tmNameLabel: "Naam van het template",
    tmSave: "Template opslaan",
    tmSaved: "Template opgeslagen",
    tmCancel: "Terug",
    tmEdit: "Bewerken",
    tmEditTitle: "Template bewerken",
    tmNewTitle: "Nieuw template",
    tmDeleteConfirm: "Dit template verwijderen?",
    tmDeleted: "Template verwijderd",
    tmPreviewHint: "Voorbeeld op basis van je standaard-CV of voorbeeldgegevens",
    tplDefaultOption: "Standaardstijl (Klassiek)",
    ncwTemplateLabel: "Kies een template (optioneel)",
    ltwTemplate: "Kies een stijl voor je brief en bijlagen",
    ltwTemplateHint: "Optioneel — het template bepaalt lettertype en accentkleur van de brief-PDF",
    ltwTplFromCv: "Zelfde stijl als het gekozen CV",
    rbTplZoneHeader: "Header",
    tplSecStyle: "Sectiestijl",
    tplSecBorder: "Omkaderen (lijn)",
    tplSecBorderOn: "Aan",
    tplSecFill: "Vulkleur",
    tplSecTextColor: "Tekstkleur",
    tplSecTitleColor: "Titelkleur",
    tplSecNone: "Geen",
    tplSecHint: "Kwast = kleuren & kader per sectie · oog = sectie verbergen · slepen = verplaatsen",
    tplSecHide: "Sectie verbergen",
    tplSecShow: "Sectie tonen",
    tmLivePreview: "Live voorbeeld",
    rbEduLevel: "Niveau",
    rbEduLevelPh: "bv. HBO",
    dashDocs: "Documenten bij deze sollicitatie",
    dashDocsTitle: "Bij deze sollicitatie",
    dashDocsCv: "CV (PDF)",
    dashDocsLetter: "Motivatiebrief",
    dashDocsValidation: "Eisen-validatie",
    dashDocsPackage: "Sollicitatiepakket",
    dashDocsSectionUploaded: "Zelf geüploade bijlage",
    dashDocsSectionLetter: "Motivatiebrief-bundel",
    dashDocsJobCv: "Bijgevoegd CV",
    dashDocsEmpty: "Nog geen bijlagen — voeg een CV toe of genereer een motivatiebrief.",
    fuTitle: "Opvolging bijwerken",
    fuHow: "Hoe heb je opgevolgd?",
    fuMethodEmail: "E-mail",
    fuMethodPhone: "Gebeld",
    fuMethodNote: "Notitie",
    fuNotePh: "bv. Gesproken met de recruiter — belt volgende week terug",
    fuResetHint: "Bij registratie start de opvolgteller opnieuw en pauzeren de reminders",
    fuSave: "Opvolging registreren",
    fuSaved: "Opvolging geregistreerd — teller opnieuw gestart",
    fuHistory: "Opvolg-log",
    fuNoHistory: "Nog geen opvolgacties geregistreerd",
    fuAuto: "automatisch",
    pageInfo: "Pagina {page} van {total}",
    pagePrev: "Vorige",
    pageNext: "Volgende",
    shareTitle: "Deelbare CV-link",
    shareHint: "Zet je CV online op een eigen link — ideaal voor je LinkedIn-bio of e-mailhandtekening",
    shareEnable: "Zet mijn CV-link aan",
    shareTurnOff: "Link uitzetten",
    shareSlugLabel: "Jouw link",
    shareCvLabel: "Welk CV deel je?",
    shareContactLabel: "Contactgegevens tonen op de openbare pagina",
    shareSave: "Instellingen opslaan",
    shareSaved: "Deellink bijgewerkt",
    shareDisabled: "Je CV-pagina is nu offline",
    shareCopy: "Kopieer link",
    shareCopySocial: "Social-link (met preview)",
    shareCopySocialHint: "Gebruik deze link op LinkedIn/WhatsApp — toont naam, functie en foto als preview",
    shareCopied: "Link gekopieerd",
    shareFieldsLabel: "Welke gegevens deel je op de openbare pagina?",
    shareFieldsHint: "Naam en functietitel staan er altijd op — de rest bepaal jij",
    rbPersonalFieldsLabel: "Welke personalia staan op dit CV?",
    rbPersonalFieldsHint: "Uitgeschakelde gegevens verschijnen niet op de PDF van dit CV",
    rbPersonalNoneFilled: "Je profiel bevat nog geen persoonsgegevens om te tonen. Vul deze eerst in via Profiel → Persoonlijke gegevens; daarna verschijnen hier chips om per veld te tonen of te verbergen.",
    ppEmailPrefs: "E-mailvoorkeuren",
    ppDigestLabel: "Wekelijkse voortgangsmail",
    ppDigestHint: "Elke week een rustig overzicht: nieuwe sollicitaties, gesprekken en wie op opvolging wacht",
    ppDigestOn: "Wekelijkse voortgangsmail staat aan",
    ppDigestOff: "Wekelijkse voortgangsmail staat uit",
    ppFollowupsLabel: "Opvolg-herinneringen",
    ppFollowupsOn: "Opvolg-herinneringen staan aan",
    ppFollowupsOff: "Opvolg-herinneringen staan uit",
    ppTrashRemindersLabel: "Prullenbak-waarschuwingen",
    ppTrashRemindersOn: "Prullenbak-waarschuwingen staan aan",
    ppTrashRemindersOff: "Prullenbak-waarschuwingen staan uit",
    ppArchiveExpiryLabel: "Archief-vervalwaarschuwing",
    ppArchiveExpiryHint: "Mail 30 dagen voordat een gearchiveerde sollicitatie automatisch verdwijnt, met een directe download-link.",
    ppArchiveExpiryOn: "Vervalwaarschuwing archief staat aan",
    ppArchiveExpiryOff: "Vervalwaarschuwing archief staat uit",
    // Testimonials submission section on profile
    tsEyebrow: "JOUW VERHAAL",
    tsTitle: "Deel je JobGrid-ervaring",
    tsBody: "Schrijf een korte quote over hoe JobGrid je heeft geholpen. Na goedkeuring rouleert je verhaal automatisch op de posters die onze partners printen.",
    tsSubmitCta: "Deel je quote",
    tsEmpty: "Je hebt nog geen quote ingezonden. Deel je verhaal in één minuut en help anderen.",
    tsLoading: "Bezig met laden…",
    tsStatusPending: "In review",
    tsStatusApproved: "Goedgekeurd",
    tsStatusRejected: "Afgekeurd",
    tsAnonymous: "Anoniem",
    tsWithdraw: "Terugtrekken",
    tsWithdrawnDone: "Inzending teruggetrokken",
    tsWithdrawFailed: "Terugtrekken mislukt",
    ppSendSample: "Stuur mij een voorbeeld",
    ppSampleSent: "Voorbeeld verzonden — check je inbox",
    ppSampleFailed: "Versturen mislukt — is het domein geverifieerd in Resend?",
    ppMembership: "Lidmaatschap",
    ppMemStatusLabel: "Status",
    ppMemTrial: "Proefperiode",
    ppMemActive: "Actief abonnement",
    ppMemExpired: "Verlopen",
    ppMemAdmin: "Beheerder · Onbeperkt",
    ppMemAdminPlan: "Onbeperkt",
    ppMemPlanLabel: "Plan",
    ppMemPlanMonthly: "Maandelijks · €9,95/maand",
    ppMemPlanYearly: "Jaarlijks · €79/jaar",
    ppMemPlanTrial: "Gratis proefperiode",
    ppMemUntil: "Geldig tot",
    ppMemDaysLeft: "Nog {days} dagen",
    ppMemCancelledNote: "Opgezegd — je houdt toegang tot de einddatum, daarna wordt er niets meer verlengd.",
    ppMemCancelBtn: "Abonnement opzeggen",
    ppMemCancelConfirm: "Weet je zeker dat je je abonnement wilt opzeggen? Je houdt toegang tot de einddatum.",
    ppMemCancelDone: "Je abonnement is opgezegd",
    ppMemUpgrade: "Direct upgraden",
    ppMemCancelHint: "Maandelijks opzegbaar — opzeggen stopt de verlenging, je toegang blijft tot de einddatum.",
    ppInvoices: "Facturen",
    ppInvoicesHint: "Je betalingen via Stripe — download elke factuur als PDF",
    ppNoInvoices: "Nog geen facturen.",
    ppInvoiceDl: "Download",
    shareOpen: "Bekijk pagina",
    shareViews: "{n} weergaven",
    pubDownload: "Download PDF",
    pubNotFound: "Deze CV-pagina bestaat niet (meer).",
    pubMadeWith: "Dit CV is gemaakt met",
    pubCta: "Maak ook zo'n CV — gratis proberen",
    priceSaveBadge: "Bespaar 34%",
    priceSaveBanner: "Jaartoegang: €79 i.p.v. €119,40 — 34% voordeel",
    rbPersonalFromProfile: "Adres, e-mail, telefoon, geboortedatum en foto beheer je centraal onder ‘Jouw profiel’ — ze worden automatisch op elke CV-PDF gebruikt.",
    navProfile: "Jouw profiel",
    ppTitle: "Jouw profiel",
    ppHint: "Deze gegevens worden automatisch op elke CV-PDF gebruikt.",
    ppData: "Persoonsgegevens",
    ppBirthdate: "Geboortedatum",
    ppBirthdatePh: "bv. 12-05-1988",
    ppPhotoHint: "Verschijnt bovenin je CV (vorm kies je in de Template designer) · JPG/PNG/WEBP, max 5 MB",
    rbTplClassic: "Klassiek",
    rbTplClassicHint: "Monochroom, zakelijk",
    rbTplModern: "Modern",
    rbTplModernHint: "Petrol accent met getinte zijbalk",
    rbTplElegant: "Elegant",
    rbTplElegantHint: "Serif met gouden accenten",
    rbPreview: "Voorbeeld",
    rbPreviewTitle: "PDF-voorbeeld",
    rbPreviewBusy: "Genereren…",
    rbPreviewRefresh: "Vernieuwen",
    rbPhoto: "Pasfoto (optioneel)",
    rbPhotoUpload: "Foto uploaden",
    rbPhotoRemove: "Foto verwijderen",
    rbPhotoHint: "Verschijnt bovenaan de zijbalk van de PDF · JPG/PNG/WEBP, max 5 MB",
    rbPhotoUploaded: "Foto opgeslagen",
    rbPhotoRemoved: "Foto verwijderd",
    rbAutosaving: "Opslaan…",
    rbAutosavePending: "Wijzigingen…",
    rbAutosaved: "Opgeslagen",
    rbEditorBack: "Terug naar overzicht",
    rbLivePreview: "Live-voorbeeld",
    rbTplQuick: "Template",
    rbPreviewAutoHint: "Het voorbeeld ververst automatisch na elke wijziging",
    rbPreviewHide: "Verbergen",
    rbPreviewShow: "Voorbeeld tonen",
    rbMobileEdit: "Bewerken",
    rbMobilePreview: "Voorbeeld",
    emwTitle: "E-mail naar vacatureplaatser",
    emwTo: "Aan (e-mailadres)",
    emwToPh: "recruiter@bedrijf.nl",
    emwAttach: "Wat stuur je mee?",
    emwAttachCv: "CV (PDF)",
    emwAttachLetter: "Motivatiebrief (PDF)",
    emwAttachPackage: "Sollicitatiepakket (PDF)",
    emwNoLetter: "Nog geen motivatiebrief aan deze sollicitatie gekoppeld — maak er eerst een via de brief-wizard.",
    emwPitchAttach: "Video-pitch link meesturen",
    emwPitchAttachIntro: "Bekijk mijn korte video-pitch:",
    emwPitchSrcLetter: "Vacature-pitch",
    emwPitchSrcFavorite: "Favoriet-pitch",
    emwPitchSrcElevator: "Elevator pitch",
    emwSubject: "Onderwerp",
    emwBody: "E-mailtekst (aanpasbaar)",
    emwGenerating: "Standaardtekst genereren…",
    emwRegenerate: "Opnieuw genereren",
    emwOpenMail: "Open in e-mailprogramma",
    emwAttachHint: "De gekozen PDF's zijn gedownload — voeg ze als bijlage toe aan de e-mail.",
    emwGenerateFailed: "Genereren mislukt — probeer opnieuw",
    emwType: "Soort e-mail",
    emwTypeIntro: "Introductie",
    emwTypeFollowup: "Opvolging",
    emwStaleHint: "Deze sollicitatie is al {days} dagen zonder reactie — een opvolgmail is voorgesteld.",
    ncwStep1: "Stap 1 · Waarmee wil je starten?",
    ncwStep2: "Stap 2 · Wat neem je over?",
    ncwStep3: "Stap 3 · Persoonlijke gegevens",
    ncwStep4: "Stap 4 · Titel van de CV",
    ncwStep5: "Stap 5 · Opslaan als",
    ncwDone: "Je CV-variant staat klaar!",
    ncwBaseExisting: "Op basis van een bestaande CV-variant",
    ncwBaseExistingHint: "Kopieer een CV die je al hebt en pas alleen aan wat anders moet. Ideaal wanneer je snel wilt richten op één specifieke vacature.",
    ncwBaseNew: "Geheel nieuw opbouwen",
    ncwBaseNewHint: "Start met een lege variant en vul alles zelf in. Kies dit voor een compleet nieuw profiel of als je vanaf nul wilt beginnen.",
    ncwBaseCentral: "Uit mijn standaard CV (AI)",
    ncwBaseCentralHint: "AI leest je eerder geüploade standaard-CV en zet die om naar bewerkbare secties. Kies dit als je al een CV in je profiel hebt staan.",
    ncwBaseFile: "Uit een nieuw bestand (AI)",
    ncwBaseFileHint: "Upload een PDF of DOCX (ook uit LinkedIn) en AI vult de secties automatisch voor je in. Kies dit als je een CV extern hebt staan.",
    ncwPickBase: "Kies de basis-variant",
    ncwTakeAll: "Alles overnemen",
    ncwTakeAllHint: "Profiel, ervaringen, vaardigheden, opleiding — alles",
    ncwTakeSome: "Zelf onderdelen selecteren",
    ncwTakeSomeHint: "Kies welke ervaringen en vaardigheden meegaan",
    ncwSelectExp: "Werkervaringen",
    ncwSelectSkills: "Vaardigheden",
    ncwShowFull: "Volledige persoonlijke gegevens tonen",
    ncwShowFullHint: "Adres, telefoon, e-mail en LinkedIn op de PDF",
    ncwShowNameOnly: "Alleen mijn naam",
    ncwShowNameOnlyHint: "Contactgegevens blijven weg van de PDF",
    ncwCvTitleLabel: "Titel van deze CV (bijv. Projectleider)",
    ncwCvTitlePh: "bv. Projectleider",
    ncwSaveNameLabel: "Naam om op te slaan",
    ncwCreate: "CV aanmaken",
    ncwCreating: "Aanmaken… (AI-import kan 20-40 sec duren)",
    ncwCreatedMsg: "Direct de wizard 'Nieuwe baan gezien?' starten, of ben je klaar?",
    ncwLaunchJob: "Nieuwe baan-wizard starten",
    ncwFinish: "Klaar — naar de editor",
    ncwPickBaseFirst: "Kies eerst een basis-variant",
    ncwPickFileFirst: "Kies eerst een bestand",
    ncwTitleRequired: "Geef de CV een titel",
    rbShowPersonalToggle: "Toon persoonlijke gegevens op de PDF",
    ltDlPackage: "Sollicitatiepakket (alles-in-één PDF)",

    // Pricing / billing
    priceEyebrow: "Prijzen",
    priceTitle: "Eén rustige plek voor je hele zoektocht.",
    priceSubtitle: "Maak een gratis account aan en bewaar je sollicitaties, CV's en gesprekken op één plek. Kies pas een toegangspakket wanneer je CV's of brieven wil genereren — eenmalige betaling, geen automatische verlenging. Je data blijft altijd van jou.",
    priceTrialBadge: "Toegangspakketten",
    priceMonthly: "Maandelijks",
    priceYearly: "Jaarlijks",
    pricePerMonth: "/maand",
    priceOneTime: "eenmalig",
    pricePackOnlyPerMonth: "€ {amount}/mnd · {duration}",
    pricePackDuration: "{duration} gebruiksrecht",
    pricePerYear: "/jaar",
    priceYearlySave: "Bespaar 34% t.o.v. maandelijks",
    priceBestValue: "Meest gekozen",
    priceCta: "Start met dit plan",
    priceCtaLogin: "Login om te starten",
    priceFeatAll: "Alles inbegrepen in elk pakket:",
    priceFeat1: "Onbeperkt sollicitaties volgen met gearchiveerde vacatureteksten",
    priceFeat2: "AI CV Generator met meerdere varianten (PDF in NL, EN, DE, FR, ES)",
    priceFeat3: "AI motivatiebrieven + eisen-validatie + sollicitatiepakket",
    priceFeat4: "AI interviewvoorbereiding als PDF",
    priceFeat5: "Bookmarks, notities, gespreksdata en meer",
    priceTrialNote: "Gratis account · geen creditcard nodig.",
    priceVatIncluded: "Alle prijzen zijn inclusief 21% BTW.",
    priceCtaPack: "Aan de slag",
    priceDurationDays: "{n} dagen",
    priceDurationMonth1: "1 maand",
    priceDurationMonths: "{n} maanden",
    priceDurationYear: "1 jaar",
    pricePerMonthDetail: "≈ €{amount}/mnd · {n} maanden gefactureerd",
    priceExpiredFree: "Je bent nu op een Gratis Account — je data blijft bewaard. Koop een pakket om weer te kunnen maken en downloaden.",
    cancelChoiceEyebrow: "Toegang beheren",
    cancelChoiceTitle: "Wat wil je doen?",
    cancelChoiceSoftTitle: "Naar Gratis Account",
    cancelChoiceSoftBody: "Je toegang stopt automatisch op {date} en wordt daarna omgezet naar een Gratis Account. Je data blijft bewaard — je kunt op elk moment een nieuw pakket kopen om verder te gaan.",
    cancelChoiceHardTitle: "Account definitief opheffen",
    cancelChoiceHardBody: "Alle CV's, brieven, sollicitaties en accountgegevens worden onherroepelijk gewist. Deze actie kan niet ongedaan worden gemaakt.",
    cancelChoiceReasonIntro: "We horen graag waarom je stopt — dit helpt ons JobGrid beter te maken. (Optioneel)",
    cancelChoiceNotePlaceholder: "Optionele toelichting…",
    cancelChoiceConfirmSoft: "Bevestig opzegging",
    cancelReason_job_found: "Ik heb een baan gevonden 🎉",
    cancelReason_too_expensive: "Te duur",
    cancelReason_not_useful: "Ik gebruik het te weinig",
    cancelReason_temporary_break: "Tijdelijke pauze",
    cancelReason_other: "Anders",
    common_back: "Terug",
    affTabLabel: "Affiliate",
    affPromoEyebrow: "Verdien mee — tot 15% commissie",
    affPromoTitle: "Deel JobGrid, verdien mee",
    affPromoBody: "Word affiliate en verdien tot 15% commissie op elk pakket dat via jouw link wordt gekocht. Uitbetaling zodra je €25 hebt opgebouwd — direct op je Nederlandse of Europese IBAN. Geen kosten, geen minimum, gewoon delen wat je toch al aanraadt.",
    affPromoCta: "Word affiliate — gratis",
    affPromoShareOnly: "Alleen link delen",
    affPromoShareOnlyHint: "Geen affiliate-programma nodig — deel JobGrid met vrienden. Meldt iemand zich aan en betaalt via jouw link? Dan krijg jij +14 gratis proefdagen erbovenop. Zonder IBAN of admin.",
    affPromoStatCommission: "Commissie per pakket",
    affPromoStatCookie: "Cookie-venster",
    affPromoStatPayout: "Uitbetaling vanaf",
    affPromoStatMethod: "Direct op je IBAN",

    // Process flow — how it works
    affFlowEyebrow: "Zo werkt het",
    affFlowTitle: "Vier stappen. Klaar in twee minuten.",
    affFlowStep1T: "Meld je aan",
    affFlowStep1D: "Vul je naam en IBAN in — één keer. Duurt minder dan een minuut.",
    affFlowStep2T: "Deel je link",
    affFlowStep2D: "Kant-en-klare banner voor je e-mailhandtekening, of één-klik-delen naar LinkedIn/WhatsApp/X.",
    affFlowStep3T: "Volg je kliks",
    affFlowStep3D: "Realtime dashboard: hoeveel mensen op je link klikten, hoeveel converteerden, wat je hebt verdiend.",
    affFlowStep4T: "Ontvang uitbetaling",
    affFlowStep4D: "Vanaf €25 vraag je in één klik uitbetaling aan. SEPA-transfer binnen 1–2 werkdagen.",

    // Banner preview
    affBannerPreviewEyebrow: "Voorproefje",
    affBannerPreviewTitle: "Zo ziet jouw banner eruit",
    affBannerPreviewBody: "Dit is exact het blokje dat gebruikers zien wanneer je de HTML-banner in je e-mailhandtekening of blog plakt. Klein, discreet, maar met een duidelijke call-to-action.",
    affBannerPreviewLabel: "Live preview",
    affBannerPreviewHint: "De link in de preview is inactief — na aanmelding krijg je een unieke tracking-URL die aan jouw account is gekoppeld.",

    // For who
    affForWhoEyebrow: "Ideaal voor",
    affForWho1: "Career coaches",
    affForWho2: "HR-professionals",
    affForWho3: "Content creators",
    affForWho4: "Iedereen met een netwerk",

    affWizardEyebrow: "Aanmelden",
    affWizardTitle: "Vul je bankgegevens in",
    affWizardIntro: "We hebben je IBAN nodig zodat we je verdiende commissies kunnen uitbetalen. Naam moet overeenkomen met de rekeninghouder.",
    affFieldName: "Naam rekeninghouder",
    affFieldIban: "IBAN",
    affFieldBic: "BIC (optioneel)",
    affPasteIban: "IBAN plakken vanaf klembord",
    affIbanPasted: "IBAN geplakt",
    affIbanPasteFailed: "Kon klembord niet lezen",
    affBicAutofilled: "Automatisch ingevuld",
    affIbanValid: "Geldige {country}-IBAN",
    affIbanValidWithBank: "Geldige {country}-IBAN — {bank}",
    affIbanReasonGeneric: "IBAN lijkt ongeldig",
    affIbanReasonCountry: "Landcode {country} wordt (nog) niet ondersteund",
    affIbanReasonLength: "IBAN telt {actual} tekens — verwacht {expected}",
    affIbanReasonFormat: "IBAN bevat ongeldige tekens",
    affIbanReasonChecksum: "Controlegetal klopt niet — check op typefouten",
    affWizardSubmit: "Bevestig aanmelding",
    affJoinValidationMissing: "Vul minstens naam en IBAN in",
    affJoinSuccess: "Aangemeld! Je kunt nu de banner delen.",
    affJoinFailed: "Aanmelden mislukt",
    affStatClicks7d: "Kliks (7d)",
    affStatConversions: "Conversies",
    affStatAccrued: "Opgebouwd",
    affStatPaid: "Uitbetaald",
    affPosterAttribution: "Kliks per poster",
    affPosterAttributionHint: "QR-codes op je posters zijn per variant getagd, dus zie je precies welke print het meeste opbrengt.",
    affPosterClassic: "Klassiek A4",
    affPosterBanner: "Banner A4",
    affPosterQuote: "Quote A4",
    affPosterClicksUnit: "kliks totaal",
    affPosterConversionsUnit: "conv.",
    affPosterCvrUnit: "CVR",
    affPosterWinnerLabel: "Winnaar · {v}",
    affPosterWinnerHint: "Hoogste conversieratio in de afgelopen periode. Print deze variant bij voorkeur.",
    affPayoutProgress: "Voortgang uitbetaling",
    affPayoutCta: "Uitbetaling aanvragen",
    affPayoutHint: "Nog €{need} tot je uitbetaling kunt aanvragen.",
    affPayoutRequested: "{n} conversies in de wachtrij gezet — je krijgt bericht zodra de SEPA-transfer is verwerkt.",
    affPayoutFailed: "Aanvragen mislukt",
    affShareEyebrow: "Deel je link",
    affShareIntro: "Iedereen die via deze link binnen 30 dagen een pakket koopt, telt mee voor jouw commissie.",
    affCopyBanner: "Kopieer HTML banner",
    affCopyLink: "Kopieer link",
    affDownloadPoster: "Download A4 poster (PDF)",
    affPosterClassic: "Klassiek (staand)",
    affPosterClassicDesc: "A4 portret voor kantines, prikborden en balies. Volledige verhaal met hero, bullets en trust-badge.",
    affPosterBanner: "Banner (liggend)",
    affPosterBannerDesc: "A4 landscape voor prikbord of muur. Kort en krachtig — perfect om vanaf afstand te lezen.",
    affPosterQuote: "Review-quote",
    affPosterQuoteDesc: "Testimonial-driven poster met een grote pull-quote als hero. Ideaal voor koffie-corners.",
    affPosterLangLabel: "Postertaal",
    affPosterCustomQuoteLabel: "Eigen review-quote (optioneel)",
    affPosterCustomQuoteHelp: "Overrijdt de standaard testimonial op álle 3 de varianten. Laat leeg om Sanne's quote te gebruiken.",
    affPosterCustomQuotePlaceholder: "Bijv. In één middag mijn CV af én 3 sollicitatiegesprekken geregeld…",
    affPosterCustomAttribPlaceholder: "Bijv. Mark, 29 · Junior Developer uit Amsterdam",
    affPosterDownloading: "Downloaden…",
    affPosterDownloadPdf: "Download PDF",
    affPosterEyebrow: "Print-klare posters (A4)",
    affPosterTitle: "Print & hang op — elke scan telt mee",
    affPosterHelp: "Kies een layout, print op A4 en hang op in kantines, prikborden of coworking-hubs. Elke poster bevat je eigen QR — elke scan telt mee voor je commissie.",
    affPosterClassic: "Klassiek (staand)",
    affPosterBanner: "Banner (liggend)",
    affPosterQuote: "Review-quote",
    affPosterDownloaded: "Poster gedownload — hang 'm op voor extra scans!",
    affPosterDownloadFailed: "Kon de poster niet downloaden. Probeer het opnieuw.",
    affCopy: "Kopieer",
    affCopied: "Gekopieerd",
    affShareNow: "Deel je link nu",
    affShareModalEyebrow: "Deel je affiliate-link",
    affShareModalTitle: "Klaar om je link te delen?",
    affShareModalBody: "Kies een kanaal — we zetten meteen een persoonlijke, kant-en-klare boodschap klaar. Hoe sneller je je eerste 3 kliks scoort, hoe eerder je je eerste commissie ziet.",
    affShareYourLink: "Jouw persoonlijke link",
    affShareChannels: "Delen via",
    affShareLinkedIn: "LinkedIn",
    affShareWhatsApp: "WhatsApp",
    affShareEmail: "E-mail",
    affShareMessage: "Hi, Ik gebruik JobGrid om mijn sollicitaties overzichtelijk te houden — AI-CV's, motivatiebrieven en interview-prep in één plek. Als jij ook aan het solliciteren bent, echt een aanrader:",
    affShareEmailSubject: "Sollicitatietool die ik gebruik — misschien handig voor jou",
    affShareTip: "Tip: LinkedIn kopieert je bericht ook automatisch naar je klembord — plak het in je post en klaar.",
    affShareDone: "Klaar",
    affInviteEyebrow: "Of stuur een persoonlijke uitnodiging",
    affInviteBody: "JobGrid stuurt namens jou een warme mail met korte intro en je banner. Perfect voor die ene collega die je persoonlijk wil aanraden.",
    affInviteNotePlaceholder: "Hey! Dacht dat dit iets voor jou zou zijn.",
    affInviteOptionalNote: "persoonlijke noot (optioneel)",
    affInviteSend: "Verstuur mail",
    affInviteSending: "Versturen…",
    affInviteSent: "Mail verstuurd naar {recipient} ✓",
    affInviteToastSent: "Uitnodiging verstuurd!",
    affInviteToastFailed: "Kon uitnodiging niet versturen",
    affBannerCopied: "Banner gekopieerd — plak in Gmail/Outlook signature-instellingen.",
    affBannerCopyFailed: "Kopiëren mislukt",

    // Affiliate endorsement logo
    affLogoEndorsement: "Aanbevolen door",
    affLogoEyebrow: "Jouw logo — optioneel",
    affLogoBody: "Upload je eigen logo of merk-icoon en het verschijnt onder aan de banner als «Aanbevolen door <logo>». Ideaal voor career coaches, HR-bureaus en content creators die hun naam aan de aanbeveling willen koppelen.",
    affLogoUploadCta: "Logo uploaden",
    affLogoReplaceCta: "Vervangen",
    affLogoRemoveCta: "Verwijderen",
    affLogoUploading: "Uploaden…",
    affLogoNone: "Nog geen logo",
    affLogoHint: "PNG, JPG, WEBP of SVG · maximaal 2 MB · wordt automatisch verkleind tot 400 px breed",
    affDisplayNameEyebrow: "Jouw naam of bedrijf",
    affDisplayNameBody: "Optioneel — deze verschijnt als tekst naast (of in plaats van) je logo, onder \"Aanbevolen door\" in de banner.",
    affDisplayNamePlaceholder: "Bijv. Marketing Studio Amsterdam",
    affDisplayNameSave: "Opslaan",
    affDisplayNameHint: "Max. 60 tekens. Laat leeg om alleen je logo te tonen, of alleen JobGrid.",
    affDisplayNameSaved: "Naam opgeslagen",
    affDisplayNameError: "Naam opslaan mislukt",
    affLogoTooLarge: "Bestand is te groot — max 2 MB",
    affLogoSaved: "Logo opgeslagen — je banner is bijgewerkt",
    affLogoRemoved: "Logo verwijderd",
    affLogoSaveFailed: "Opslaan mislukt",
    affLinkCopied: "Link gekopieerd",
    affLinkCopyFailed: "Kopiëren mislukt",
    affPaymentDetails: "Uitbetaalgegevens",
    affStripeEyebrow: "Nieuw · Snellere uitbetaling",
    affStripeUpgradeTitle: "Upgrade naar Stripe Connect",
    affStripeUpgradeBody: "Ontvang je commissie in minuten in plaats van dagen. Eén keer verifiëren via Stripe (paspoort + IBAN), daarna verlopen uitbetalingen automatisch. Je bestaande IBAN-flow blijft werken tot je zelf overstapt.",
    affStripeUpgradeCta: "Verifieer via Stripe →",
    affStripeResumeTitle: "Verificatie nog niet voltooid",
    affStripeResumeBody: "Je bent begonnen met de Stripe-verificatie maar hebt hem nog niet afgerond. Ga verder om automatische uitbetalingen te activeren.",
    affStripeResumeCta: "Ga verder met verifiëren →",
    affStripeReadyTitle: "Klaar voor automatische uitbetalingen via Stripe",
    affStripeReadyBody: "Toekomstige uitbetalingen komen automatisch op je gekoppelde bankrekening — meestal binnen 1-2 werkdagen.",
    affStripeStartFailed: "Stripe kon geen verificatielink genereren",
    priceBack: "Terug",
    priceExpiredBanner: "Je proefperiode is afgelopen. Kies een plan om verder te gaan waar je gebleven was.",
    priceStartTrialTitle: "Al vanaf €7,50 · aan de slag met AI",
    priceStartTrialSub: "Bereid je volledig voor op je sollicitatie: CV's downloaden, motivatiebrieven schrijven en interviews oefenen. Volledige toegang tot alle AI-tools, met een beperkt aantal CV's, motivatiebrieven en Match Scores per periode. Wil je net iets meer dan 7 dagen? Kies een groter pack met méér ruimte.",
    priceStartTrialCta: "Bekijk pakketten",
    priceTrialNoCard: "Eenmalige betaling · geen automatische verlenging",
    demoLiveEyebrow: "Live demo · 50 seconden",
    demoPlayCta: "Bekijk demo met geluid",
    demoModalLabel: "JobGrid product demo",
    demoUnmute: "Geluid aan",
    demoMute: "Geluid uit",
    demoClose: "Sluiten",
    priceTrialInc1: "AI CV's downloaden (PDF)",
    priceTrialInc2: "AI motivatiebrieven schrijven",
    priceTrialInc3: "AI Match Score & Interview-prep",
    priceTrialInc4: "10 vacaturebronnen · publieke CV-link",

    // Post-trial Free tier
    priceFreeEyebrow: "Je data blijft altijd van jou",
    priceFreeTitle: "Ook zonder actief pack: je werk blijft veilig staan",
    priceFreeSub: "Loopt je proefperiode of pack af? Geen probleem. Je CV's, motivatiebrieven en sollicitaties blijven opgeslagen en downloadbaar. Wanneer je klaar bent om weer te versnellen, activeer je met één klik een nieuw pack — alles staat direct weer aan.",
    priceFreeYesTitle: "Blijft werken",
    priceFreeYes1: "Alle bestaande CV's, brieven en sollicitaties zichtbaar",
    priceFreeYes2: "PDF-download van eerder opgeslagen documenten",
    priceFreeYes3: "Favorieten en vacature-zoeker",
    priceFreeNoTitle: "Direct actief bij nieuw pack",
    priceFreeNo1: "Nieuwe CV's + motivatiebrieven genereren",
    priceFreeNo2: "AI Match Score & Interview-prep",
    priceFreeNo3: "Publieke CV-link + video motivatiebrief",
    priceFreeNo4: "Wekelijkse Match-Radar met verse vacatures",
    priceOrCommit: "Of kies direct een toegangspakket",
    priceCheckoutFailed: "Betaling starten mislukt — probeer opnieuw",
    priceCancelMonthly: "Maandelijks opzegbaar",
    priceCancelNote: "Het maandplan is maandelijks opzegbaar — geen verplichtingen, je stopt wanneer je wilt.",

    paySuccessChecking: "Betaling controleren…",
    paySuccessOk: "Betaling geslaagd — je abonnement is actief!",
    paySuccessExpired: "De betaalsessie is verlopen. Probeer opnieuw.",
    paySuccessTimeout: "Status-controle duurt te lang. Controleer je e-mail voor de bevestiging.",
    paySuccessError: "Controle mislukt — probeer opnieuw of neem contact op.",
    paySuccessToApp: "Naar de app",
    paySuccessRetry: "Terug naar prijzen",

    subTrialBadge: "Proef · nog {days} dagen",
    subUpgrade: "Upgrade",
    subUpgradeNow: "Direct upgraden",
    subAdminLink: "Beheer",

    // Admin
    admTitle: "Beheer",
    admSubtitle: "Gebruikers, proefperiodes en abonnementen",
    plnSectionEyebrow: "Beheer · Abonnementen",
    plnSectionTitle: "Abonnementen & tarieven",
    plnNewCta: "Nieuw plan",
    plnRefresh: "Herladen",
    plnLoadFailed: "Kon abonnementen niet laden",
    plnEmpty: "Nog geen plannen aangemaakt.",
    plnNew: "Nieuw abonnement",
    plnEdit: "Abonnement bewerken",
    plnName: "Naam",
    plnSlug: "Slug (unieke code)",
    plnDescription: "Beschrijving",
    plnPriceMonthly: "Eenmalig totaal (€)",
    plnPriceMonthlyHint: "€ {total} eenmalig voor {days} dagen gebruiksrecht · ≈ € {permonth} p/m",
    plnPriceMonthlyHintEmpty: "Exact bedrag dat Stripe eenmalig afrekent bij aankoop",
    plnPriceYearly: "Prijs jaar-optie (legacy, € · optioneel)",
    plnPriceYearlyHint: "Alleen invullen voor legacy abonnementen met aparte jaar-prijs. Nieuwe eenmalige packs laten leeg.",
    plnStripeMonthly: "Stripe price ID (maand)",
    plnStripeYearly: "Stripe price ID (jaar)",
    plnLimits: "Limieten (vink 'Onbeperkt' aan · 0 = feature geblokkeerd)",
    plnMaxCvs: "Max CV-varianten",
    plnMaxLetters: "Max brieven / maand",
    plnMaxApps: "Max sollicitaties",
    plnMaxTemplates: "Max templates",
    plnMaxMatchAi: "Max Match-AI acties / maand",
    plnMaxLanguages: "Aantal talen",
    plnFeatures: "Functies",
    plnPublicCv: "Deelbare CV-link",
    plnAiInterview: "AI Interview-voorbereiding",
    plnIsDefault: "Standaard bij nieuwe accounts",
    plnIsFeatured: "Meest gekozen (donker gemarkeerd op /pricing)",
    plnActive: "Actief (zichtbaar in prijzenlijst)",
    plnSave: "Opslaan",
    plnCancel: "Annuleren",
    plnCreated: "Abonnement aangemaakt",
    plnUpdated: "Abonnement bijgewerkt",
    plnDeleted: "Abonnement verwijderd",
    plnSaveFailed: "Opslaan mislukt",
    plnDeleteFailed: "Verwijderen mislukt",
    plnConfirmDelete: "Weet je zeker dat je '{name}' wilt verwijderen? Gebruikers op dit plan gaan terug naar proefperiode.",
    plnColName: "Plan",
    plnColPrice: "Prijs",
    plnColCommission: "Affiliate",
    plnCommission: "Affiliate commissie",
    plnCommissionHint: "≈ € {euro} per verkoop wordt uitgekeerd aan de affiliate",
    plnColLimits: "Limieten & functies",
    plnColStatus: "Status",
    plnOrderSaved: "Volgorde opgeslagen",
    plnOrderFailed: "Volgorde opslaan mislukt",
    plnStatusActive: "Actief",
    plnStatusInactive: "Uit",
    plnEditBtn: "Bewerken",
    plnDeleteBtn: "Verwijderen",
    plnStripeSyncFailed: "Stripe-koppeling mislukt",
    pricePlanMaxCvs: "{n} CV-varianten",
    pricePlanUnlimitedCvs: "Onbeperkt aantal CV's",
    pricePlanMaxLetters: "{n} brieven per maand",
    pricePlanUnlimitedLetters: "Onbeperkt aantal brieven",
    pricePlanMaxApps: "{n} sollicitaties",
    pricePlanUnlimitedApps: "Onbeperkt aantal sollicitaties",
    pricePlanLangs: "{n} talen (NL, EN, DE, FR, ES)",
    pricePlanPublicCv: "Publieke deelbare CV-link",
    pricePlanAiInterview: "AI Interview-voorbereiding",
    pricePlanMaxDownloads: "{n} PDF-downloads per maand",
    pricePlanUnlimitedDownloads: "Onbeperkt PDF-downloads",
    priceFree: "Gratis",
    priceCtaFree: "Activeer gratis plan",
    priceFreeActivated: "Gratis plan geactiveerd!",
    priceMostPopular: "Meest gekozen",
    navFeedback: "Support",
    navTour: "Rondleiding",
    navProductTour: "Product-tour",
    // Product Tour video modal (menu + landing banner)
    tourEyebrow: "PRODUCT-TOUR · KORT & KRACHTIG",
    tourClipCv: "CV Builder",
    tourClipLetter: "Motivatiebrief",
    tourClipInterview: "Interview-coach",
    tourClipRadar: "Match Radar",
    tourSoon: "binnenkort",
    tourClipComingSoon: "Deze clip volgt binnenkort — Matilda staat in de studio.",
    tourFooterHint: "Escape sluit · Alle clips zijn ondertiteld",
    tourCloseCta: "Klaar",
    tourEndTitle: "Klaar om zelf te beginnen?",
    tourEndBody: "Maak je gratis account en bouw je eerste CV in 3 minuten.",
    tourStartFreeCta: "Start gratis",
    tourGoDashCta: "Naar dashboard",
    tourReplayCta: "Opnieuw bekijken",
    tourShareBtn: "Deel-link",
    tourShareTitle: "Deel deze clip",
    tourShareHint: "Kopieer en deel de link — de tour opent automatisch op deze clip.",
    tourShareCopy: "Kopieer link",
    tourShareCopied: "Gekopieerd!",
    // Two-factor (user profile)
    tfaEyebrow: "Beveiliging",
    tfaTitle: "Tweefactor-authenticatie",
    tfaBody: "Zet 2FA aan zodat inloggen ook een 6-cijferige code uit je authenticator-app vraagt. Werkt met Google Authenticator, Authy, 1Password of Bitwarden — offline en zonder SMS.",
    tfaStatusOn: "2FA staat aan",
    tfaStatusOff: "2FA staat uit",
    tfaOffHint: "Aanbevolen — je account is een stuk moeilijker te kraken.",
    tfaEnableBtn: "2FA inschakelen",
    tfaActivatedOn: "Ingeschakeld op",
    tfaCodesLeft: "{n} backup-codes over",
    tfaStep1: "Stap 1 · Scan de QR met je authenticator-app",
    tfaStep2: "Stap 2 · Vul de 6-cijferige code in",
    tfaManualLabel: "Handmatig invoeren?",
    tfaConfirming: "Bevestigen…",
    tfaConfirmBtn: "Bevestig & schakel 2FA in",
    tfaEnabled: "2FA ingeschakeld — bewaar je backup-codes op een veilige plek!",
    tfaDisabled: "2FA uitgeschakeld",
    tfaConfirmDisable: "Weet je zeker dat je 2FA wilt uitschakelen? Je account is dan minder goed beveiligd.",
    tfaBackupEyebrow: "Bewaar deze backup-codes",
    tfaBackupTitle: "Je 8 eenmalige backup-codes",
    tfaBackupBody: "Bewaar deze codes veilig (wachtwoordmanager of print ze uit). Ze redden je login als je je telefoon kwijt bent — en werken elk maar één keer.",
    tfaCopyAll: "Kopieer alle codes",
    tfaCopiedAll: "Alle backup-codes gekopieerd",
    tfaBackupHide: "Ik heb ze bewaard — verberg",
    tfaDisableTitle: "2FA uitschakelen",
    tfaDisableHint: "Vul een geldige code uit je authenticator-app in om 2FA uit te zetten.",
    tfaDisableBtn: "2FA uitschakelen",
    tfaErrSetup: "Setup mislukt",
    tfaErrCode: "Code klopt niet",
    // Landing banner
    landTourBadge: "NIEUW · VIDEO-TOUR",
    landTourBannerBody: "Zie in één minuut hoe je een gerichte CV maakt.",
    landTourCta: "Bekijk tour",
    landTourPreviewEyebrow: "PRODUCT-TOUR · SNEAK PEEK",
    landTourPreviewTitle: "Zie wat je krijgt — 4 clips van 20 seconden",
    landTourPreviewHint: "Klik op een tegel om die clip meteen te bekijken",
    navRecommend: "Aanbevelen",

    // Recommend dialog (Aanbevelen)
    recEyebrow: "Aanbevelen",
    recTitle: "JobGrid aanbevelen bij iemand?",
    recIntro: "Kies hoe je het wilt doen. Beide manieren delen dezelfde site — het enige verschil is wat jij ervoor terugkrijgt.",
    recPlainTitle: "Aanbevelen",
    recPlainBody: "Deel JobGrid met een vriend, collega of familielid. Als iemand via jouw link een pakket koopt, krijg jij 🎁 14 dagen extra toegang als bedankje.",
    recAffiliateTitle: "Word partner én verdien commissie",
    recAffiliateBody: "Zelfde link, maar bij elke betaling ontvang je een percentage in cash. Perfect als je JobGrid vaker deelt.",
    recAffiliateActiveTitle: "Je bent al partner",
    recAffiliateActiveBody: "Kijk in Jouw profiel → Affiliate voor je persoonlijke link met commissie-tracking.",
    recBack: "Terug",
    recShareEyebrow: "Deel de link",
    recShareTitle: "Deel JobGrid",
    recShareIntro: "Stuur de link via WhatsApp, e-mail of sociale media.",
    recGiftPromise: "Als iemand via jouw link een pakket koopt, verlengen we jouw toegang automatisch met 14 dagen — je krijgt een bevestigingsmail.",
    recThankYou: "Bedankt voor het aanbevelen! 💛",
    recShareMessage: "Hi, Ik gebruik JobGrid om mijn sollicitaties bij te houden, mijn CV op te frissen en motivatiebrieven te schrijven. Misschien handig voor jou ook —",
    recShareEmailSubject: "Kijk eens: JobGrid — alles voor je sollicitatie op één plek",
    recCopy: "Kopieer",
    recCopied: "Gekopieerd",
    recLinkCopied: "Link gekopieerd — plak 'm in je bericht",
    recSwitchToAffiliate: "Wist je dat je ook 15% commissie kunt verdienen? Word partner →",
    navTrash: "Prullenbak",
    trashTitle: "Prullenbak",
    trashLead: "Verwijderde items blijven {days} dagen bewaard. Daarna worden ze definitief verwijderd. Je kunt ze binnen die periode altijd terugzetten.",
    trashEmpty: "Prullenbak is leeg",
    trashEmptyHint: "Verwijderde CV's, motivatiebrieven en sollicitaties verschijnen hier.",
    trashColLabel: "Naam",
    trashColKind: "Type",
    trashColDaysLeft: "Nog te herstellen",
    trashColActions: "Acties",
    trashKind_resume: "CV",
    trashKind_letter: "Brief",
    trashKind_job: "Sollicitatie",
    trashDaysLeft: "{days} dagen",
    trashRestore: "Terugzetten",
    trashHardDelete: "Definitief verwijderen",
    trashRestored: "Item teruggezet",
    trashHardDeleted: "Item definitief verwijderd",
    trashConfirmHard: "Definitief verwijderen? Deze actie kan niet ongedaan gemaakt worden.",
    trashConfirmEmpty: "Alle {count} items definitief verwijderen? Dit kan niet ongedaan worden gemaakt.",
    trashEmptied: "{count} items definitief verwijderd",
    trashEmptyAll: "Prullenbak legen",
    obStepOf: "Stap {current} van {total}",
    obNext: "Volgende",
    obPrev: "Terug",
    obSkip: "Overslaan",
    obFinish: "Klaar",
    obStep1Title: "Welkom bij JobGrid",
    obStep1Body: "In een paar korte stappen laten we je zien hoe je hier het meeste uithaalt: van profiel en CV tot sollicitaties, motivatiebrieven en interviewvoorbereiding. Klaar? Klik 'Volgende'.",
    obStep2Title: "Vul eerst je profiel",
    obStep2Body: "Je persoonlijke gegevens (naam, adres, contact) worden automatisch overal ingevuld. Zo hoef je dit maar één keer te doen.",
    obStep3Title: "Kies of ontwerp een sjabloon",
    obStep3Body: "Bepaal hoe jouw CV eruitziet: lettertype, kleur, indeling en achtergrond. Sjablonen kun je op elke CV opnieuw gebruiken.",
    obStep4Title: "Nodig je referenties uit",
    obStep4Body: "Vraag oud-collega's en managers om een korte referentie. Zij bevestigen via een link en jij downloadt ze als PDF of voegt ze toe in je CV",
    obStep5Title: "Bouw je CV-varianten",
    obStep5Body: "Maak meerdere CV's — bijvoorbeeld één voor projectleider en één voor consultant. De AI helpt je met tekst en samenvattingen.",
    obStep6Title: "Registreer een sollicitatie",
    obStep6Body: "Klik hier om een nieuwe vacature toe te voegen en een motivatiebrief erbij te maken. Plak de link en JobGrid haalt automatisch functie, bedrijf en beschrijving op, of plak de vacature.",
    obStep7Title: "Genereer een motivatiebrief",
    obStep7Body: "Bij elke sollicitatie kun je in seconden een op de vacature afgestemde motivatiebrief laten schrijven — in vijf talen.",
    obStepMatchTitle: "Verhoog je match-score",
    obStepMatchBody: "Elke motivatiebrief krijgt een Match-score % t.o.v. de vacature. Vanuit de brief-editor open je de Match-verbeter Wizard: AI geeft concrete tips, herschrijft je CV (met feit-check op je bestaande ervaring) en levert een verse brief met hogere score. Perfect om laat-getest je sollicitatie op te tillen.",
    obStepPrepTitle: "Bereid je interview voor met AI",
    obStepPrepBody: "Zodra je een sollicitatie hebt ingeschoten, klik je in het overzicht op het ster-icoon naast de vacature. JobGrid genereert dan verwachte vragen, sterke antwoorden op basis van jouw CV, en een gesprekplan — inclusief PDF-download. Zo loop je voorbereid het interview in.",
    obStep8Title: "Volg je pipeline",
    obStep8Body: "Het overzicht toont de status van alle sollicitaties, herinneringen voor follow-ups en interviewdata. Alles op één plek.",
    obStep9Title: "Veel succes!",
    obStep9Body: "Je bent klaar om te beginnen. Deze rondleiding kun je altijd opnieuw starten via de knop 'Rondleiding' in de zijbalk.",

    // New: JobSearch onboarding steps
    obStepJobSearchTitle: "Vind vacatures — één plek voor alles",
    obStepJobSearchBody: "Klik op 'Vacatures zoeken' om LinkedIn, Indeed, Glassdoor en Adzuna in één keer te doorzoeken. Elk resultaat kun je met één klik aan je tracker toevoegen.",
    obStepJobBrancheTitle: "Filter op branche",
    obStepJobBrancheBody: "De chips onder het zoekvak (IT, Zorg, Marketing, Sales, …) filteren de resultaten server-side op de door jou gekozen branche. Ideaal om vacatures te focussen op wat écht relevant is.",
    obStepJobMatchTitle: "AI Match met je CV",
    obStepJobMatchBody: "Klik 'Bereken match' en Gemini vergelijkt jouw CV met elke gevonden vacature. De slider verbergt vacatures onder je minimum-match (standaard 50%). Groen = sterke match, oranje = redelijk, rood = zwak.",
    obStepJobToLetterTitle: "Van vacature naar motivatiebrief — in één klik",
    obStepJobToLetterBody: "De sterkste flow van JobGrid: zie je een geschikte vacature? Klik op 'Motivatiebrief' bij het resultaat. De vacature wordt gearchiveerd, en de brief-wizard opent direct met titel, bedrijf en beschrijving vooringevuld. AI schrijft een brief op maat — jij hoeft alleen te versturen.",
    obTourEyebrow: "Rondleiding",
    obJumpTo: "Ga naar stap",

    // Partner tour steps (standalone tour launched from AffiliatePanel)
    obPartner1Title: "Welkom bij het partner-programma",
    obPartner1Body: "In deze korte rondleiding zie je hoe je verdient met JobGrid: jouw unieke link delen, een banner in je e-mail zetten en je eigen merk toevoegen als «Aanbevolen door».",
    obPartner2Title: "Jouw unieke link",
    obPartner2Body: "Deze link telt iedereen mee die binnen 30 dagen na een klik betaalt. Deel 'm via LinkedIn, WhatsApp of e-mail — zichtbaar op je profiel.",
    obPartner3Title: "Deel in één klik",
    obPartner3Body: "De deelknop opent een modal met kant-en-klare berichten voor LinkedIn, WhatsApp, X en e-mail. Je link wordt automatisch toegevoegd.",
    obPartner4Title: "Banner in je e-mailhandtekening",
    obPartner4Body: "Kopieer de HTML-banner en plak 'm in de handtekening-instellingen van Gmail of Outlook. Iedereen in je CC ziet het.",
    obPartner5Title: "Eigen logo → «Aanbevolen door»",
    obPartner5Body: "Optioneel: upload je merk-logo en het verschijnt onder aan de banner als 'Aanbevolen door [jouw logo]'. Perfect voor coaches, HR-bureaus of bloggers.",
    obPartner6Title: "Uitbetalingen",
    obPartner6Body: "Je opgebouwde commissie kun je vanaf €25 laten uitbetalen — automatisch via Stripe Connect of handmatig via IBAN. Veel succes!",

    // Partner tour CTA in the affiliate dashboard
    affDashEyebrow: "Partner dashboard",
    affDashTitle: "Jouw partner-programma",
    affPartnerTourCta: "Rondleiding partner-programma",
    // References editor
    refEditCta: "Referentie bewerken",
    refEditEyebrow: "Referentie",
    refEditTitle: "Details bewerken",
    refEditSaved: "Referentie bijgewerkt",
    refEditSave: "Opslaan",
    refEditShareTitle: "Zichtbaar in PDF-export",
    refEditShareHint: "Vink de velden aan die in het gedeelde PDF-overzicht mogen verschijnen. Wat je uitvinkt blijft privé in je administratie.",
    refFormName: "Naam",
    refFormEmail: "E-mail",
    refFormPhone: "Telefoon",
    refFormRelationship: "Relatie / rol",
    refFormRoleTitle: "Functie",
    refFormCompany: "Bedrijf",
    refFormYearsKnown: "Aantal jaren bekend",
    refFormNote: "Notitie / aanbeveling",
    refField_name: "Naam",
    refField_role_title: "Functie",
    refField_company: "Bedrijf",
    refField_email: "E-mail",
    refField_phone: "Telefoon",
    refField_relationship: "Relatie",
    refField_years_known: "Jaren bekend",
    refField_note: "Notitie",
    cancel: "Annuleren",
    jobAttTitle: "Bijlagen",
    recFormsTitle: "Recruiter-formulier",
    recFormsUploadCta: "Formulier invullen",
    recFormsUploadCta2: "Automatisch invullen",
    recFormsUploadBusy: "AI vult in…",
    recFormsUploadHint: "Upload een .docx recruiter-formulier — de AI vult de open velden op basis van je brief, eisen-validatie en gekozen referenties.",
    recFormsEmpty: "Nog geen ingevulde formulieren. Upload een recruiter-.docx om te starten.",
    recFormsPickerEyebrow: "Nieuw formulier",
    recFormsPickerTitle: "Selecteer referenties om mee te sturen",
    recFormsPickerBody: "De AI vult voor jou naam, contactgegevens, motivatie-antwoorden en werkervaring in op basis van de sollicitatie-context. Kies eventueel welke goedgekeurde referenties mogen worden gedeeld.",
    recFormsValPrevTitle: "Eisen die klaar staan voor invulling",
    recFormsValPrevBody: "Deze eisen komen uit je Eisen-validatie. Als een vraag in het formulier hiermee overeenkomt, wordt het exacte antwoord gebruikt — 1-op-1 zoals de recruiter dat in je validatie-PDF ziet.",
    recFormsValPrevMore: "+ {n} meer tonen",
    recFormsValPrevEmpty: "Nog geen Eisen-validatie beschikbaar — de AI vult open velden puur op basis van je CV en brief.",
    recFormsPickRefs: "Goedgekeurde referenties",
    recFormsFilled: "{n} velden ingevuld — download start.",
    recFormsFail: "Invullen mislukt — probeer opnieuw.",
    recFormsWrongType: "Alleen .docx-bestanden worden ondersteund.",
    recFormsDelete: "Verwijderen",
    recFormsDeleteConfirm: "Dit formulier definitief verwijderen?",
    recFormsRowMeta: "{n} velden ingevuld · {when}",
    recFormsAnalyzeCta: "Analyseren met AI",
    recFormsAnalyzing: "AI analyseert…",
    recFormsPreviewEyebrow: "Controleer & pas aan",
    recFormsPreviewBody: "De AI heeft {n} velden herkend, waarvan {empty} nog leeg zijn. Controleer, pas antwoorden aan waar nodig, en klik daarna op 'Bevestigen & Downloaden'.",
    recFormsPreviewNoFields: "Geen invulbare velden gevonden — het document lijkt geen open plekken te bevatten.",
    recFormsPreviewFooter: "{n} velden totaal · {empty} nog leeg",
    recFormsApplyCta: "Bevestigen & Downloaden",
    recFormsApplying: "Document wordt geschreven…",
    recFormsFieldType: "Type",
    recFormsPlaceholderLabel: "Placeholder",
    recFormsFieldPlaceholder: "Antwoord…",
    recFormsAltHint: "Alternatieven",
    recFormsConf_high: "Zeker",
    recFormsConf_medium: "Waarschijnlijk",
    recFormsConf_low: "Controleer",
    recFormsSrc_cv: "Uit CV",
    recFormsSrc_job: "Uit vacature",
    recFormsSrc_ai: "AI-gegenereerd",
    recFormsSrc_reference: "Uit referentie",
    recFormsSrc_letter: "Uit motivatiebrief",
    recFormsSrc_validation: "Uit eisen-validatie",
    recFormsMeetsLabel: "Voldoe je hieraan",
    recFormsMeets_ja: "Ja",
    recFormsMeets_nee: "Nee",
    recFormsMeets_gedeeltelijk: "Gedeeltelijk",
    recFormsSrc_empty: "Nog leeg",
    jobAttCv: "CV",
    jobAttCvNone: "Geen CV gekoppeld",
    jobAttLetter: "Motivatiebrief",
    jobAttLetterNone: "Nog geen brief aangemaakt",
    jobAttValidation: "Eisen-validatie",
    jobAttValidationReady: "Klaar om te bekijken",
    jobAttValidationNone: "Wordt aangemaakt met de brief",
    jobAttOpen: "Openen",
    jobAttDownload: "Downloaden",
    jobAttDownloadFailed: "Downloaden mislukt — probeer opnieuw.",
    jobAttUpdated: "Bijgewerkt",
    ltwSourceMode: "Bron van de vacature",
    ltwSourceNew: "Nieuw",
    ltwSourceExisting: "Uit sollicitaties",
    ltwSearchJob: "Zoek in je sollicitaties…",
    ltwPickedJob: "Gekozen",
    ltwGeneratedWithJob: "Sollicitatie automatisch aangemaakt in je overzicht",
    ltwOpenLetter: "Brief openen",
    ltwOpenValidation: "Eisen-validatie openen",
    ltwValidationReady: "Eisen-validatie klaar",
    dangerZoneEyebrow: "Gevarenzone",
    dangerZoneTitle: "Account opzeggen",
    dangerZoneBody: "Weet je zeker dat je JobGrid wilt verlaten? Kies of je je account wilt omzetten naar een gratis versie (je gegevens blijven 12 maanden bewaard na je laatste login) of alles definitief wilt verwijderen.",
    cancelAccountCta: "Opzeggen",
    cancelEyebrow: "Account",
    cancelTitle: "Opzeggen",
    cancelDowngradeTitle: "Omzetten naar gratis account",
    cancelDowngradeBody: "Je Abonnementsverplichting wordt gestopt en je account blijft nog 12 maanden na je laatste login beschikbaar. Je CV's, brieven en sollicitaties blijven bewaard tot die datum.",
    cancelDowngradeConfirm: "Bevestig omzetting",
    cancelDeleteTitle: "Volledig verwijderen",
    cancelDeleteBody: "Alles wordt direct en definitief verwijderd: CV's, motivatiebrieven, sollicitaties, referenties en instellingen. Deze actie is onomkeerbaar.",
    cancelDeleteWarning: "Deze actie is onomkeerbaar. Alle gegevens gekoppeld aan je account worden direct verwijderd.",
    cancelDeleteConfirm: "Definitief verwijderen",
    cancelDeleteConfirmLabel: "Typ '{word}' om te bevestigen",
    cancelReasonLabel: "Reden (helpt ons verbeteren)",
    cancelNoteLabel: "Toelichting (optioneel)",
    cancelReasonJobFound: "Ik heb een baan gevonden",
    cancelReasonTooLittle: "Ik gebruikte het te weinig",
    cancelReasonExpect: "Voldeed niet aan mijn verwachtingen",
    cancelReasonOther: "Anders",
    cancelDowngradeDone: "Omgezet naar gratis account",
    cancelDeleteDone: "Account verwijderd",
    ticketEyebrow: "Feedback",
    ticketTitle: "Bug melden of suggestie doen",
    ticketKindLabel: "Wat wil je melden?",
    ticketKindBug: "Bug",
    ticketKindSuggestion: "Suggestie",
    ticketSubjectLabel: "Onderwerp",
    ticketDescriptionLabel: "Beschrijving",
    ticketSubjectBugPlaceholder: "Bijv. Knop 'Opslaan' doet niets",
    ticketSubjectSuggestionPlaceholder: "Bijv. Ik zou graag CSV-export willen",
    ticketDescriptionBugPlaceholder: "Beschrijf wat je deed, wat je verwachtte en wat er gebeurde. Screenshot-URL erbij mag ook.",
    ticketDescriptionSuggestionPlaceholder: "Beschrijf de functie of verbetering die je graag zou zien, en waarom.",
    ticketRequired: "Vul beide velden in.",
    ticketSubmit: "Verstuur",
    ticketCancel: "Annuleren",
    ticketSent: "Bedankt! Je bericht is verstuurd.",
    ticketFailed: "Versturen mislukt — probeer het opnieuw.",
    ticketHistory: "Jouw eerdere tickets",
    ticketHistoryEmpty: "Nog geen tickets ingediend.",
    ticketAdminReply: "Antwoord van beheer",
    ticketStatusOpen: "Open",
    ticketStatusInProgress: "In behandeling",
    ticketStatusResolved: "Opgelost",
    ticketStatusClosed: "Gesloten",
    ticketAdmEyebrow: "Beheer · Tickets",
    ticketAdmTitle: "Bugs & suggesties",
    ticketAdmStatus: "Status",
    ticketAdmReplyLabel: "Antwoord (zichtbaar voor gebruiker)",
    ticketAdmReplyPlaceholder: "Kort antwoord of update…",
    ticketAdmSave: "Opslaan",
    ticketAdmSaveFailed: "Opslaan mislukt",
    ticketAdmLoadFailed: "Kon tickets niet laden",
    ticketAdmEmpty: "Geen tickets voor dit filter.",
    ticketStatTotal: "Totaal",
    ticketStatOpen: "Open",
    ticketStatIn_progress: "In behandeling",
    ticketStatInProgress: "In behandeling",
    ticketStatResolved: "Opgelost",
    ticketStatBug: "Bugs",
    ticketStatSuggestion: "Suggesties",
    footerCompany: "Contactgegevens",
    footerContact: "Contact",
    contactEyebrow: "Contact",
    contactTitle: "Neem contact op",
    contactSubtitle: "Vragen, feedback of samenwerking? Vul het formulier in en we reageren binnen 1 werkdag.",
    contactBack: "Terug",
    contactName: "Naam",
    contactEmail: "E-mailadres",
    contactSubject: "Onderwerp",
    contactMessage: "Bericht",
    contactSubmit: "Versturen",
    contactSent: "Bedankt — je bericht is verstuurd!",
    contactFailed: "Bericht kon niet verstuurd worden — probeer het opnieuw.",
    contactSuccessTitle: "Verstuurd!",
    contactSuccessBody: "We hebben je bericht ontvangen en reageren binnen 1 werkdag.",
    contactSendAnother: "Nog een bericht sturen",
    contactDetailsEyebrow: "Bedrijfsgegevens",
    ppTicketNotifyLabel: "E-mail bij ticket-updates",
    ppTicketNotifyOn: "Notificaties aan",
    ppTicketNotifyOff: "Notificaties uit",
    ppFollowupDaysLabel: "Standaard opvolg-datum (dagen na aanmelden)",
    ppFollowupDaysHint: "Nieuwe sollicitaties krijgen automatisch deze opvolg-datum. Je kunt 'm per sollicitatie aanpassen.",
    admNavOverview: "Overzicht",
    admNavPlans: "Abonnementen",
    admNavUsers: "Gebruikers",
    admNavTickets: "Tickets",
    admNavEmails: "E-mails",
    admNavTransactions: "Transacties",
    admNavEvents: "Activiteit",
    admNavBranding: "Huisstijl",
    admNavSecurity: "Beveiliging",
    admNavTestimonials: "Reviews",
    admNavAffiliates: "Affiliates",
    admInvitesEyebrow: "Invite-activiteit",
    admInvitesTitle: "Wie stuurt actief uitnodigingen?",
    admCashflowEyebrow: "Cashflow-check",
    admCashflowTitle: "Kun je alle openstaande commissies uitbetalen?",
    admCashflowBody: "Vergelijkt je live Stripe platform-saldo met de totale openstaande commissie. Groen = ruime buffer, geel = krap, rood = tekort → wacht met transfers tot nieuwe verkopen zijn afgerekend.",
    admCashflowRefresh: "Ververs",
    admCashflowStripeBalance: "Stripe saldo",
    admCashflowPending: "Openstaande commissie",
    admCashflowPendingClearance: "in verwerking bij Stripe",
    admCashflowConversions: "conversies",
    admCashflowGapPositive: "Voldoende buffer voor alle uitbetalingen",
    admCashflowGapNegative: "Tekort — nieuwe verkopen nodig",
    admCashflowHealthHealthy: "Gezond",
    admCashflowHealthIdle: "Geen openstaande",
    admCashflowHealthTight: "Krap",
    admCashflowHealthCritical: "Tekort!",
    admCashflowErrorHint: "(mogelijk: STRIPE_API_KEY nog placeholder — werkt na deploy)",
    admInvitesBody: "Zie welke affiliates echt hun netwerk aanspreken en welke opgemeld staan maar niets doen. Handig om gerichte follow-up te sturen naar dormant partners.",
    admInvitesStatSends: "Verstuurde mails",
    admInvitesStatOpens: "Opens",
    admInvitesStatClicks: "Kliks",
    admInvitesStatRecipients: "Unieke ontvangers",
    admInvitesStatActive: "Actieve verzenders",
    admInvitesStatDormant: "Dormant partners",
    admInvitesTopSenders: "Top verzenders",
    admInvitesEmpty: "Nog geen invites verstuurd in dit venster.",
    admInvitesEmptyHint: "Je hebt {total} affiliates opgemeld — overweeg ze een korte reminder te sturen dat de invite-flow beschikbaar is.",
    admInvitesColAffiliate: "Affiliate",
    admInvitesColSends: "Verstuurd",
    admInvitesColOpens: "Opens",
    admInvitesColClicks: "Kliks",
    admInvitesColRecipients: "Ontvangers",
    admInvitesColConversions: "Conversies",
    admInvitesColLastSent: "Laatst",
    admAffTitle: "Affiliate uitbetalingen",
    admAffIntro: "Alle affiliates met openstaande commissies. Voer de SEPA-transfer uit vanuit je bank-app en markeer daarna als betaald.",
    admAffColAffiliate: "Affiliate",
    admAffColIban: "IBAN",
    admAffColConversions: "Conversies",
    admAffColAmount: "Bedrag",
    admAffColStatus: "Status",
    admAffColActions: "Acties",
    admAffStatusPending: "Openstaand",
    admAffStatusRequested: "Aangevraagd",
    admAffEmpty: "Geen openstaande uitbetalingen.",
    admAffMarkPaid: "Markeer betaald",
    admAffPayStripe: "Via Stripe",
    admAffPayStripeConfirm: "Direct via Stripe Connect uitbetalen? De transfer wordt onmiddellijk verzonden en gemarkeerd als betaald.",
    admAffStripePaid: "{amount} verstuurd via Stripe ({n} conversies).",
    admAffMarkPaidConfirm: "Alle openstaande conversies van deze affiliate markeren als betaald? Doe dit pas nadat de SEPA-transfer is uitgevoerd.",
    admAffMarkedPaid: "{n} conversies gemarkeerd als betaald.",
    admAffCopyIban: "Kopieer IBAN",
    admAffCopied: "Gekopieerd",
    admTsTitle: "Reviews modereren",
    admTsIntro: "Goedgekeurde reviews verschijnen op de landingspagina. Verwijderen kan niet ongedaan worden gemaakt.",
    admTsFilterAll: "Alles",
    admTsFilterPending: "In afwachting",
    admTsFilterApproved: "Goedgekeurd",
    admTsFilterQueue: "Wachtrij",
    admTsFilterRejected: "Afgekeurd",
    admTsStatusRejected: "Afgekeurd",
    admTsReject: "Afwijzen",
    admTsRejected: "Inzending afgewezen",
    admTsNoteLabel: "Notitie",
    admTsNotePlaceholder: "Korte review-notitie (optioneel)…",
    admTsDeleteHint: "Definitief verwijderen — geen weg terug",
    admTsAnon: "Anoniem",
    admTsQueueEmpty: "Wachtrij is leeg — geen inzendingen om te reviewen.",
    admTsQueueAllClear: "Nieuwe inzendingen komen automatisch bovenin.",
    admTsCatAll: "Alle categorieën",
    admTsCatUser: "Gebruikers",
    admTsCatPartner: "Partners",
    admTsColAuthor: "Auteur",
    admTsColQuote: "Quote",
    admTsColRating: "Rating",
    admTsColSubmitted: "Ingediend",
    admTsColStatus: "Status",
    admTsColActions: "Acties",
    admTsEmpty: "Geen reviews in deze categorie.",
    admTsApprove: "Goedkeuren",
    admTsDelete: "Verwijderen",
    admTsDeleteConfirm: "Deze review definitief verwijderen?",
    admTsApproved: "Review goedgekeurd — nu zichtbaar op de landingspagina.",
    admTsDeleted: "Review verwijderd.",
    admTsStatusPending: "In afwachting",
    admTsStatusApproved: "Goedgekeurd",
    admInsightsTitle: "Laatste 7 dagen",
    admInsightsHint: "Rolling window — data ververst automatisch elke 5 minuten.",
    admInsightsNewUsers: "Nieuwe gebruikers",
    admInsightsRevenue: "Omzet",
    admInsightsPending: "Openstaande acties",
    admInsightsPerDay: "per dag",
    admInsightsSince: "afgelopen 7 dagen",
    admDigestWeeklyCta: "Weekly digest testen",
    admDigestWeeklyHint: "Verstuurt direct de wekelijkse admin-samenvatting (nieuwe gebruikers, omzet, openstaande acties) — vergelijkbaar met wat elke maandagochtend om 08:00 UTC automatisch de deur uitgaat.",
    admDigestWeeklySent: "Weekly digest verstuurd naar {n} admin(s).",
    admFunnelTitle: "Conversion funnel",
    admFunnelHint: "Rolling window · laatste {days} dagen · CVR% t.o.v. vorige stap",
    admFunnelStepView: "Landing views",
    admFunnelStepClick: "CTA-clicks",
    admFunnelStepSignup: "Signups",
    admFunnelStepPaid: "Betaalde upgrades",
    admFunnelVariant: "Variant {v}",
    brndTitle: "Logo & Huisstijl",
    brndIntro: "Upload een eigen logo (PNG, SVG, JPEG of WebP, max ~500 KB). Wordt direct actief in de header van elke pagina — geen deploy nodig. Reset om terug te vallen op het standaard JobGrid-woordmerk.",
    brndDefaultLabel: "Standaard-logo actief",
    brndActive: "Er is momenteel een eigen logo actief. Vervangen of resetten hieronder.",
    brndInactive: "Er is nog geen eigen logo geüpload. Het standaard JobGrid-woordmerk wordt getoond.",
    brndUpload: "Logo uploaden",
    brndUploadReplace: "Vervang logo",
    brndResetCta: "Terug naar standaard",
    brndResetConfirmTitle: "Logo resetten?",
    brndResetConfirmBody: "Het geüploade logo wordt verwijderd en de app valt terug op het standaard JobGrid-woordmerk. Deze actie is niet ongedaan te maken (je kunt wel opnieuw uploaden).",
    brndResetConfirmCta: "Ja, reset",
    brndReset: "Logo gereset naar standaard.",
    brndUploaded: "Logo bijgewerkt — het is nu overal actief.",
    brndHint: "Elke afbeelding wordt automatisch geresized naar 240px (langste zijde) — je hoeft dus geen exacte afmetingen aan te leveren. Groot en scherp uploaden mag; het resultaat wordt scherp gerenderd op retina schermen.",
    brndErrTooLarge: "Bestand is groter dan 500 KB — kies een kleiner bestand.",
    brndErrType: "Alleen PNG, JPEG, SVG of WebP worden ondersteund.",
    brndErrGeneric: "Upload mislukt — probeer opnieuw.",
    brndStripeManual: "Logo geüpload naar Stripe. Rond de koppeling eenmalig af in het Stripe Dashboard → Settings → Branding om het ook op facturen te tonen.",
    brndStripeOpen: "Open Stripe",
    admEventsRefresh: "Ververs",
    admEventsSearchPlaceholder: "Zoek in gebeurtenissen…",
    admEventsEmpty: "Nog geen gebeurtenissen — upgrades en limiet-overschrijdingen verschijnen hier.",
    admEventsLevel_all: "Alle",
    admEventsLevel_info: "Info",
    admEventsLevel_success: "Succes",
    admEventsLevel_warn: "Waarschuwing",
    admEventsLevel_error: "Fout",
    admOverviewEventsTitle: "Recente activiteit",
    admOverviewEventsAll: "Bekijk alle",
    admRelJustNow: "zojuist",
    admRelMinAgo: "{n} min geleden",
    admRelHourAgo: "{n} uur geleden",
    admRelDayAgo: "{n} dgn geleden",
    admBellTooltip: "Meldingen",
    admBellTitle: "Recente activiteit",
    admBellEmpty: "Nog geen activiteit — upgrades en limiet-overschrijdingen verschijnen hier.",
    plnMaxDownloads: "Max PDF-downloads / maand",
    plnStatActive: "Actieve abonnees",
    plnStatActiveShort: "actief",
    plnStatMrr: "MRR (maand)",
    plnStatArr: "ARR (jaar)",
    admForbidden: "Alleen voor beheerders.",
    admBackToApp: "Naar de app",
    admStatUsers: "Gebruikers",
    admStatTrial: "In proefperiode",
    admStatActive: "Actieve abonnementen",
    admStatExpired: "Verlopen",
    admStatNew7: "Nieuw (7 dgn)",
    admStatRevenue: "Omzet totaal",
    admStatRevenue30: "Omzet (30 dgn)",
    admFilterAll: "Alle",
    admFilterTrial: "Proef",
    admFilterActive: "Actief",
    admFilterExpired: "Verlopen",
    admFilterAdmin: "Admins",
    admSearchPh: "Zoek op naam of e-mail…",
    admColUser: "Gebruiker",
    admColStatus: "Status",
    admColPlan: "Plan",
    admColTrialEnds: "Proef t/m",
    admColSubEnds: "Abonnement t/m",
    admColSince: "Sinds",
    admColActions: "Acties",
    admLabelTrial: "PROEF",
    admLabelActive: "ACTIEF",
    admLabelExpired: "VERLOPEN",
    admLabelAdmin: "ADMIN",
    admLabelFriendsFamily: "F&F",
    admActExtend: "+7 dgn proef",
    admActGrant30: "+30 dgn abo",
    admActGrant365: "+1 jaar abo",
    admActRevoke: "Intrekken",
    admActAdmin: "Admin aan/uit",
    admActBillingExemptOff: "Friends & Family",
    admActBillingExemptOn: "F&F aan",
    admActBillingExemptHint: "Geen betaalverzoek — volledige toegang zonder abonnement",
    admActReset: "Reset wachtwoord",
    admActResetHint: "Zet handmatig een nieuw wachtwoord voor deze gebruiker",
    admActResetPrompt: "Nieuw wachtwoord voor {email} (min. 8 tekens, letters + cijfers):",
    admActResetInvalid: "Wachtwoord moet min. 8 tekens zijn en zowel letters als cijfers bevatten.",
    admActResetOk: "Wachtwoord van {email} gereset — direct bruikbaar",
    admActionOk: "Bijgewerkt",
    admActionFailed: "Actie mislukt",
    admTransactions: "Transacties",
    admTxEmpty: "Nog geen transacties.",
    admNoUsers: "Geen gebruikers gevonden.",
    admDaysLeft: "{days} dgn resterend",

    // Landing
    landNavPricing: "Prijzen",
    landNavPartner: "Partner worden",
    landNavLogin: "Inloggen",
    landH1a: "Vind, schrijf, presteer —",
    landH1accent: "met AI",
    landH1b: "van vacature tot aanbod.",
    landSub: "JobGrid scant tien vacatureplatforms in één keer, schrijft je CV en motivatiebrief op maat, coacht je interviewvoorbereiding en stuurt wekelijks een AI-Match-radar met verse vacatures. Alles op één rustige plek — van eerste klik tot getekend contract.",
    landCtaTrial: "Maak een gratis account aan",
    landCtaPricing: "Bekijk prijzen",
    landFloatTitle: "Vandaag in je sollicitatieoverzicht",
    landFeaturesEyebrow: "In deze editie",
    landFeaturesTitle: "Alles voor een doordachte sollicitatie.",
    spEyebrow: "Vertrouwd door professionals",
    spHeadline: "Duizenden sollicitanten zijn u al voorgegaan — met scherpere brieven, hogere match-scores en een rustiger overzicht.",
    spQuote1Body: "Match-score AI gaf mijn brief een 87% en ik werd meteen uitgenodigd voor het gesprek. Nooit meer zonder.",
    spQuote1Name: "Anne · Utrecht · Marketeer",
    spQuote2Body: "Eindelijk één plek waar ik alle sollicitaties, CV-varianten en vervolgstappen bij elkaar heb. Rustgevend.",
    spQuote2Name: "Jeroen · Amsterdam · Product Owner",
    spQuote3Body: "De AI-CV op maat van de vacature scheelde me uren werk — en de recruiter belde binnen twee dagen.",
    spQuote3Name: "Layla · Rotterdam · Data Analyst",
    mobStickyTitle: "Solliciteer met aandacht",
    mobStickyHint: "Gratis account · geen creditcard",
    mobStickyCta: "Start",
    imwCelebration: "Wat een sprong — jouw match steeg met {delta} punten. Klaar om te versturen.",
    spShareCta: "Deel jouw ervaring",
    revTitle: "Deel jouw JobGrid-ervaring",
    revIntro: "Kort verhaal over hoe JobGrid je helpt. Wordt na goedkeuring van een moderator getoond op de landingspagina.",
    revRating: "Beoordeling",
    revBody: "Jouw quote",
    revBodyPh: "Bijv. 'Match-AI gaf mijn brief 87% en ik werd binnen een dag uitgenodigd.'",
    revAlias: "Voornaam",
    revRole: "Rol",
    revCity: "Plaats",
    revMod: "We tonen alleen voornaam, rol en plaats. Wordt handmatig gemodereerd binnen 48 uur.",
    revSubmit: "Verstuur ter goedkeuring",
    revSending: "Versturen…",
    revThanks: "Bedankt — we bekijken je bericht en zetten het live zodra goedgekeurd.",
    revErrShort: "Vertel iets meer — minstens 20 tekens.",
    revErrGeneric: "Kon je bericht niet versturen — probeer opnieuw.",
    addPasteText: "Of plak de volledige vacature-tekst",
    addPasteTextPh: "Kopieer een LinkedIn/Indeed vacature, e-mail of PDF — AI verdeelt de velden.",
    addPasteTextHelp: "Handig als er geen URL beschikbaar is. Minimaal 60 tekens.",
    addParseTextCta: "AI verdeelt de velden",
    addParseTextBusy: "AI leest de vacature…",
    addParseTextOk: "Velden gevuld — controleer even.",
    addParseTextFail: "AI kon de tekst niet verwerken — probeer opnieuw of vul handmatig in.",
    landFeat1T: "Archiveer elke vacature",
    landFeat1D: "Plak een URL — titel, bedrijf en tekst worden bewaard, ook als de vacature verdwijnt.",
    landFeat2T: "AI CV Generator",
    landFeat2D: "Meerdere CV-varianten, wizards voor ervaringen en profiel, PDF in 5 talen (NL, EN, DE, FR, ES).",
    landFeat3T: "Motivatiebrieven die kloppen",
    landFeat3D: "Brief + eisen-validatie op maat van vacature en CV — als één sollicitatiepakket te downloaden.",
    landFeat4T: "Interviewvoorbereiding",
    landFeat4D: "Bedrijfsinfo, pitch en gesprekspunten als nette PDF.",
    landFeat5T: "Eén rustig sollicitatieoverzicht",
    landFeat5D: "Status, kanaal, tarief, gespreksdata en notities — niets te vergeten.",
    landFeatRefsT: "Referenties zonder gedoe",
    landFeatRefsD: "Beheer je referenties op één plek. Vraag ze met één klik akkoord — zij bepalen zelf welke gegevens gedeeld worden. Op je publieke CV staat altijd 'Referenties op aanvraag'.",
    landFeat6T: "Vacature Criteria Match",
    landFeat6D: "Hoe sluit jouw CV aan? AI legt je CV naast de eisen uit de vacature en laat per criterium zien waar je sterk staat — en wat je in je brief moet uitlichten.",
    landFeat6Badge: "Nieuw",
    landFeat6Match: "Match per criterium",
    landFeatWizardBadge: "Match-verbeter Wizard",
    landFeatWizardT: "Van gemiddelde score naar topfit — in 4 stappen",
    landFeatWizardD: "De AI leest je vacature, spot precies welke wording, ervaring en formulering in je CV nog kunnen groeien, herschrijft je CV met behoud van álle feiten en genereert direct een nieuwe motivatiebrief plus bijgewerkte match-score.",
    landFeatWizardExample: "Voorbeeld: je solliciteert op Senior Projectleider (vereist HBO + Scrum). Je CV mist het diploma maar toont 8 jaar leiderschap. De wizard herschrijft je profiel zodat je werk- en denkniveau meteen voelbaar is — en positioneert je Agile-praktijk als 'werkt al zo, certificering kan volgen'. Score: 62% → 89%.",
    landFeatWizardStep1: "Advies met projectie",
    landFeatWizardStep2: "CV-herschrijving (diff)",
    landFeatWizardStep3: "Nieuwe motivatiebrief",
    landFeatWizardStep4: "Score-vergelijk voor/na",
    landFeatWizardGuard: "AI verzint niets. Elke herschrijving verwijst terug naar bestaande CV-regels — feit-checkbaar.",
    landFeat7T: "Ontwerp je eigen Template",
    landFeat7D: "In een paar simpele stappen zet je jouw huisstijl in een CV-template: kies lettertype, kleuren, layout en fotokader — en gebruik hem voor al je sollicitaties.",
    landFeat7Badge: "Nieuw",
    landFeat7Step1: "Kies layout",
    landFeat7Step2: "Kleur & lettertype",
    landFeat7Step3: "Sla op & gebruik",
    landFeatPortfolioBadge: "Portfolio · uniek",
    landFeatPortfolioT: "Van links naar een print-klaar portfolio-boekje",
    landFeatPortfolioD: "Plak je project-URL's en JobGrid crawlt automatisch de site, pakt screenshots, schrijft de projectbeschrijving met AI en giet alles in een magazine-stijl portfolio met AI-cover. Deel als publieke link of exporteer als PDF.",
    landFeatPortfolioBullet1: "Playwright crawlt elke site en pakt teksten, meta én screenshots",
    landFeatPortfolioBullet2: "AI-cover (Nano Banana) matcht met de kleuren van je gekozen template",
    landFeatPortfolioBullet3: "Verantwoordelijkheden-veld: laat direct zien wat JIJ deed op elk project",
    landFeatPortfolioBullet4: "Publieke share-link met NL/EN switcher + PDF-export in beide talen",
    landFeatPortfolioExport: "PDF · Public link · Multi-taal",
    landFeat8T: "Solliciteer in vijf talen",
    landFeat8D: "Nederlands, Engels, Duits, Frans of Spaans — JobGrid schrijft je CV én motivatiebrief in de taal die de vacature vraagt. Geen ruwe Google Translate, geen dure vertaalbureau. AI herkent de taal van de vacature en past toon en formuleringen aan de lokale sollicitatiecultuur aan.",
    landFeat8Badge: "USP",
    landFeat8LangsTitle: "Beschikbare talen",
    landFeat8Lang1: "Nederlands",
    landFeat8Lang2: "Engels",
    landFeat8Lang3: "Duits",
    landFeat8Lang4: "Frans",
    landFeat8Lang5: "Spaans",
    landFeat8Auto: "Vacature-taal wordt gedetecteerd en schrijft de CV automatisch initieel in die taal",
    landPricingTitle: "Kies je toegangspakket · start vandaag",
    landPricingSub: "Start gratis met de proefperiode, of ga direct los met een pack voor onbeperkte toegang. Eenmalige betaling, geen creditcard nodig, geen automatische verlenging. Je data blijft altijd van jou.",
    landTeaserEntryEyebrow: "Instap · 7 dagen",
    landTeaserEntryPrice: "eenmalig",
    landTeaserEntryDuration: "7 dagen beperkte toegang",
    landTeaserBestEyebrow: "Voordeligste · 90 dagen",
    landTeaserBestDuration: "90 dagen onbeperkt · ≈ €25/mnd equivalent",
    landPricingCta: "Alle details & starten",
    landFooterAdmin: "Beheer",
    landFooterPricing: "Prijzen",
    landFooterTag: "Vacatures vinden, CV, motivatiebrief en interviewvoorbereiding met AI — allemaal op één rustige plek.",

    // Partner ("Partner worden") — public marketing page for the affiliate programme
    partnerEyebrow: "Partnerprogramma",
    partnerH1a: "Deel JobGrid,",
    partnerH1accent: "verdien mee",
    partnerH1b: "— zonder gedoe.",
    partnerHeroSub: "Ken je iemand die druk aan het solliciteren is, coach je professionals, of heb je een netwerk van HR-mensen? Word JobGrid Partner en verdien tot 15% commissie op elke Access Pack die via jouw link gekocht wordt.",
    partnerCtaOpenTab: "Open Affiliate-tabblad",
    partnerCtaLoginToJoin: "Inloggen om aan te melden",
    partnerCtaSeePricing: "Bekijk de pakketten",
    partnerCtaNoAccountYet: "Nog geen account? Maak er gratis eentje aan",
    partnerHeroFootnote: "Aanmelden gaat via je JobGrid-account (Profiel → Affiliate). Uitbetaling per SEPA op je eigen IBAN.",

    partnerCommissionEyebrow: "Commissie per verkoop",
    partnerCommissionSub: "Van elke Access Pack die via jouw link verkocht wordt — inclusief pakketten van 7 tot 365 dagen.",
    partnerFactCookie: "Cookie-venster",
    partnerFactPayoutFrom: "Uitbetaling vanaf",
    partnerDays: "dagen",

    partnerWhatEyebrow: "Wat is het?",
    partnerWhatTitle: "Een simpel affiliate-programma voor iedereen die JobGrid oprecht kan aanbevelen.",
    partnerWhatBody1: "JobGrid Partner is ons affiliate-programma. Je krijgt een persoonlijke referral-link en een gratis HTML-banner (voor e-mailhandtekening, blog of nieuwsbrief). Iedereen die via jouw link een betaald Access Pack koopt, telt mee voor jouw commissie.",
    partnerWhatBody2: "Geen deadlines, geen minimum aantal verkopen, geen inkoop. Je verdient een percentage van élke succesvolle verkoop en kunt uitbetalen zodra je €25 hebt opgebouwd — rechtstreeks op je Nederlandse of Europese IBAN.",

    partnerBenefitsEyebrow: "Waarom partner worden?",
    partnerBenefitsTitle: "Vier redenen om vandaag nog te starten.",
    partnerBenefit1T: "Tot 15% commissie",
    partnerBenefit1D: "Je verdient een substantieel percentage op elke Access Pack — of dat nu de 7-dagen-toegang of het jaarpakket is. Hoe langer het pakket, hoe hoger je uitbetaling per conversie.",
    partnerBenefit2T: "30 dagen cookie-window",
    partnerBenefit2D: "Klikt iemand vandaag op je link en koopt hij pas over drie weken? Geen probleem — zolang de aankoop binnen 30 dagen plaatsvindt, telt hij mee voor jou.",
    partnerBenefit3T: "Transparant dashboard",
    partnerBenefit3D: "Zie in je Profiel-tabblad je kliks, conversies, opgebouwde commissie en uitbetaalstatus. Geen verborgen aftrek, geen wachten op maandrapporten.",
    partnerBenefit4T: "SEPA-uitbetaling op eigen IBAN",
    partnerBenefit4D: "Vanaf €25 vraag je in één klik uitbetaling aan. Wij verwerken de SEPA-transfer handmatig naar het IBAN dat je hebt opgegeven — geen tussenpartij, geen kosten.",

    partnerHowEyebrow: "Hoe werkt het?",
    partnerHowTitle: "Vier stappen. Klaar in twee minuten.",
    partnerStep1T: "Meld je aan",
    partnerStep1D: "Log in op JobGrid en open het Affiliate-tabblad in je profiel. Vul je naam en IBAN in — meer niet.",
    partnerStep2T: "Deel je link of banner",
    partnerStep2D: "Kopieer je persoonlijke referral-link of de kant-en-klare HTML-banner en plak in je e-mailhandtekening, blog, LinkedIn-post of nieuwsbrief.",
    partnerStep3T: "Volg je verdiensten",
    partnerStep3D: "In het dashboard zie je real-time hoeveel mensen op je link klikken, hoeveel er converteren en wat je hebt opgebouwd aan commissie.",
    partnerStep4T: "Ontvang uitbetaling",
    partnerStep4D: "Zodra je €25 hebt opgebouwd, vraag je met één klik uitbetaling aan. Je krijgt automatisch bericht zodra de SEPA-transfer is uitgevoerd.",

    partnerForWhoEyebrow: "Voor wie?",
    partnerForWhoTitle: "Partner worden is voor iedereen die JobGrid oprecht zou aanbevelen.",
    partnerForWhoSub: "Je hoeft geen enorm bereik te hebben. Als je één of twee mensen per maand écht helpt met hun sollicitatie, verdien je al mee. Populair bij:",
    partnerForWho1: "Career coaches en loopbaanbegeleiders",
    partnerForWho2: "Recruiters en HR-professionals",
    partnerForWho3: "Content creators (LinkedIn, YouTube, nieuwsbrieven)",
    partnerForWho4: "CV-schrijvers en re-integratiebureaus",
    partnerForWho5: "Iedereen met een netwerk van werkzoekenden",

    partnerSignupEyebrow: "Aanmelden",
    partnerSignupTitle: "Klaar om partner te worden?",
    partnerSignupBody: "Aanmelden kan alleen vanuit je eigen JobGrid-account. Zo weten we zeker dat je uitbetalingen op de juiste IBAN terechtkomen en dat je toegang hebt tot je persoonlijke dashboard.",
    partnerHowToJoinLabel: "Zo meld je je aan in 4 stappen",
    partnerJoin1: "Log in op JobGrid (of maak gratis een account aan).",
    partnerJoin2: "Ga naar je Profiel en klik op het tabblad \"Affiliate\".",
    partnerJoin3: "Klik op \"Word affiliate\" en vul je naam en IBAN in.",
    partnerJoin4: "Klaar — je persoonlijke link en HTML-banner staan direct klaar om te delen.",

    partnerFaqEyebrow: "Veelgestelde vragen",
    partnerFaqTitle: "Nog vragen?",
    partnerFaq1Q: "Zitten er kosten aan verbonden?",
    partnerFaq1A: "Nee. Meedoen is volledig gratis en er zijn geen minimum-verplichtingen. Je verdient alleen als er via jouw link daadwerkelijk een Access Pack gekocht wordt.",
    partnerFaq2Q: "Hoeveel commissie krijg ik precies?",
    partnerFaq2A: "Tot 15% van de verkoopprijs van elke Access Pack. De exacte commissie per pakket zie je in je affiliate-dashboard. Zowel korte trials als jaarpakketten tellen mee.",
    partnerFaq3Q: "Wanneer krijg ik uitbetaald?",
    partnerFaq3A: "Zodra je opgebouwde commissie €25 of hoger is, kun je in één klik uitbetaling aanvragen. Wij verwerken de SEPA-transfer meestal binnen enkele werkdagen.",
    partnerFaq4Q: "Wat als iemand pas na een week koopt?",
    partnerFaq4A: "Geen probleem. We gebruiken een cookie van 30 dagen. Klikt iemand vandaag op je link en koopt hij binnen een maand? Dan is de conversie voor jou.",
    partnerFaq5Q: "Kan ik meedoen als ik in het buitenland woon?",
    partnerFaq5A: "Ja. Elke IBAN binnen SEPA (grofweg de EU + EER + UK) werkt. Buiten SEPA kunnen we op dit moment helaas niet uitbetalen.",

    // Partner voices (partner-category testimonials, empty-state invite)
    partnerVoicesEyebrow: "Partners aan het woord",
    partnerVoicesTitle: "Wat andere partners over JobGrid zeggen.",
    partnerVoicesEmptyTitle: "Deel jouw partner-verhaal.",
    partnerVoicesEmptyEyebrow: "Word ambassadeur",
    partnerVoicesEmptyBody: "Het partnerprogramma is nieuw — dus jouw verhaal komt hier als eerste te staan. Meld je aan, ontvang je eerste commissie en deel via je affiliate-dashboard hoe JobGrid je netwerk helpt.",

    // Partner-story CTA in affiliate dashboard
    affStoryEyebrow: "Deel je verhaal",
    affStoryTitle: "Ben je enthousiast over JobGrid Partner?",
    affStoryBody: "Deel in één zin wat het je oplevert. Na goedkeuring komt je quote op de publieke Partner-pagina te staan — extra zichtbaarheid voor jou én meer aanmeldingen voor JobGrid.",
    affStoryCta: "Deel mijn partner-verhaal",

    revTitlePartner: "Deel je partner-verhaal",
    revIntroPartner: "Vertel in max. 400 tekens waarom JobGrid Partner voor jou werkt. Na goedkeuring door een beheerder plaatsen we je quote op de publieke Partner-pagina.",

    landFooterTag: "Vacatures vinden, CV, motivatiebrief en interviewvoorbereiding met AI — allemaal op één rustige plek.",

    // Job search (Adzuna + JSearch)
    navJobSearch: "Vacatures zoeken",
    navPortfolios: "Portfolio",
    // Portfolio module
    pfTitle: "Mijn portfolio's",
    pfSubtitle: "Bundel je projecten in één klikbare showcase — met QR-code, PDF-download en een publieke deelbare link.",
    pfEmpty: "Nog geen portfolio's",
    pfEmptyHint: "Maak je eerste portfolio aan om je projecten te verzamelen.",
    pfNew: "Nieuw portfolio",
    pfWizardTitle: "Nieuw portfolio aanmaken",
    pfWizardNameLabel: "Naam van het portfolio",
    pfWizardNamePh: "bv. Mijn UX-werk 2026",
    pfWizardTaglineLabel: "Ondertitel (optioneel)",
    pfWizardTaglinePh: "Korte oneliner voor de coverpagina",
    pfCreate: "Aanmaken",
    pfEditorBack: "Terug naar portfolio's",
    pfItemsCount: "{n} projecten",
    pfAddItem: "+ Project toevoegen",
    pfDownloadPdf: "PDF downloaden",
    pfShareLink: "Deelbare link",
    pfShareCopied: "Link gekopieerd",
    pfPublicHint: "Deze link kan iedereen bekijken zonder in te loggen.",
    pfItemNamePh: "Projectnaam",
    pfItemDescLabel: "Projectbeschrijving",
    pfItemDescPh: "Beschrijf het project — probleem, aanpak, resultaat…",
    pfItemRespPh: "Verantwoordelijkheden — wat heb jij gedaan? Rol, taken, resultaten…",
    pfItemRespLabel: "Verantwoordelijkheden",
    pfItemSkillsLabel: "Top gerelateerde vaardigheden",
    pfItemSkillsHelp: "Kies uit je CV-skills welke bij dit project horen. Ze worden als tags getoond op je publieke portfolio en in de PDF.",
    pfItemSkillsSearchPh: "Filter vaardigheden…",
    pfItemSkillsNoCv: "Geen CV-vaardigheden gevonden. Voeg eerst skills toe onder \"Mijn CV's\" — daarna kun je ze hier kiezen.",
    pfItemSkillsNoMatch: "Geen vaardigheid gevonden.",
    pfItemSkillsLimitReached: "Maximaal 25 vaardigheden per project.",
    pfItemSkillsAiCta: "AI stel voor",
    pfItemSkillsAiBusy: "AI zoekt matches…",
    pfItemSkillsAiEmpty: "AI vond geen duidelijke match — probeer je beschrijving iets uit te breiden.",
    pfItemSkillsAiFail: "AI-suggestie mislukt — probeer opnieuw.",
    pfItemSkillsAiNeedText: "Vul eerst een beschrijving of verantwoordelijkheden in.",
    pfItemSkillsAiHint: "Klik een suggestie om 'm toe te voegen, of accepteer alles in één keer.",
    pfItemSkillsAiAcceptAll: "Accepteer alle ({n})",
    pfItemSkillsAiAdded: "{n} vaardigheden toegevoegd.",
    pfAiRewriteDesc: "AI beschrijving",
    pfAiRewriteResp: "AI verantwoordelijkheden",
    pfItemUrlPh: "https://... (optioneel)",
    pfAiRewrite: "AI herschrijven",
    pfAiRewriting: "AI herschrijft…",
    pfCrawlHint: "Website ophalen",
    pfCrawlBusy: "Website ophalen…",
    pfImageUpload: "Afbeelding toevoegen",
    pfImageUploading: "Uploaden…",
    pfSaveItem: "Project opslaan",
    pfEditItem: "Bewerken",
    pfDeleteItem: "Verwijderen",
    pfDeleteConfirm: "Dit project uit het portfolio verwijderen?",
    pfDeletePortfolio: "Portfolio verwijderen",
    pfDeletePortfolioConfirm: "Weet je zeker dat je dit portfolio wilt verwijderen? Deze actie is definitief.",
    jsEyebrow: "Vacatures zoeken",
    jsTitle: "Vind vacatures zonder tabs te wisselen",
    jsBody: "We doorzoeken LinkedIn, Indeed, Glassdoor en Adzuna in één keer. Voeg een resultaat met één klik toe aan je Sollicitatieoverzicht — de vacaturetekst wordt automatisch mee gearchiveerd.",
    jsFieldQ: "Functie of trefwoord",
    jsFieldLocation: "Locatie",
    jsSearch: "Zoeken",
    jsResults: "{n} resultaten",
    jsSources: "Bronnen",
    jsSourcesLinkedIn: "LinkedIn",
    jsSourcesIndeed: "Indeed",
    jsSourcesGlassdoor: "Glassdoor",
    jsSourcesAdzuna: "Adzuna",
    jsSourcesOther: "Overig",
    jsSourcesLegend: "Wij tonen resultaten van de grootste vacatureplatforms in Nederland en België.",
    jsEmptyTitle: "Geen vacatures gevonden voor deze zoekopdracht.",
    jsEmptyHint: "Probeer andere trefwoorden, een bredere locatie, of pas de dienstverband-filters aan.",
    jsLoadingTitle: "Even zoeken bij LinkedIn, Indeed en Adzuna…",
    jsLoadingHint: "Het combineren van meerdere bronnen kan een paar seconden duren.",
    jsRefresh: "Ververs",
    jsRefreshHint: "Nieuwe zoekopdracht uitvoeren en de cache negeren",
    jsTabSearch: "Zoeken",
    jsTabFavorites: "Favorieten",
    jsFavAdd: "Bewaar",
    jsFavRemove: "Bewaard",
    jsFavAdded: "Aan favorieten toegevoegd",
    jsFavRemoved: "Uit favorieten verwijderd",
    jsHideCta: "Niet voor mij",
    jsHideDone: "Vacature verborgen — je ziet 'm niet meer terug",
    jsHideUndo: "Ongedaan maken",
    jsHideUndone: "Vacature weer zichtbaar",
    jsHideUndoFail: "Kon niet ongedaan gemaakt worden",
    jsHideFail: "Kon vacature niet verbergen",
    jsSortLabel: "Sortering",
    jsSortNone: "Standaard",
    jsSortHigh: "Match hoog",
    jsSortLow: "Match laag",
    jsSortHint: "Sorteer resultaten op match-percentage",
    jsHideReasonTitle: "Waarom niet voor jou?",
    jsHideReasonHint: "Optioneel — helpt de AI om vergelijkbare vacatures voortaan lager te scoren.",
    jsHideReasonSalary: "Salaris te laag",
    jsHideReasonLocation: "Verkeerde locatie",
    jsHideReasonLevel: "Verkeerd niveau",
    jsHideReasonWorktime: "Werktijd past niet",
    jsHideReasonPh: "Of typ je eigen reden…",
    jsHideReasonSubmit: "Verbergen",
    jsHideReasonSkip: "Overslaan",
    jsFavError: "Kon favoriet niet bijwerken",
    jsFavEmptyTitle: "Nog geen favorieten opgeslagen",
    jsFavEmptyHint: "Klik op het hartje bij een zoekresultaat om deze hier te bewaren voor later.",
    jsFavCount: "{n} favorieten",
    jsFavMatchBody: "Onze AI scoort al je favoriete vacatures tegen je CV. Scores blijven bewaard tot je opnieuw berekent.",
    jsFavMatchRun: "Match favorieten met mijn CV",
    jsFavMatchRerun: "Herbereken favorieten",
    jsCoachTitle: "AI-tip: welke skill of ervaring zou je match verhogen?",
    jsCoachRun: "Match-Coach",
    jsCoachRefresh: "Ververs tip",
    jsCoachThinking: "Denken…",
    jsCoachLabel: "Match-Coach — versterk dit",
    jsCoachFailed: "Coach-tip mislukt — probeer opnieuw",
    jsAddToTracker: "Voeg toe",
    jsClickForDetails: "Klik voor details",
    jsDetailClose: "Sluiten",
    jsDetailExternal: "Bekijk bij bron",
    jsDetailNoBody: "Geen omschrijving beschikbaar. Bekijk de vacature bij de bron voor de volledige tekst.",
    jsAdded: "Toegevoegd ✓",
    jsAddAndLetter: "+ Motivatiebrief",
    jsFavPitch: "Video-pitch",
    jsFavPitchTitle: "Neem een korte video-pitch op voor deze vacature (AI schrijft je script mee)",
    jsCueCardsTitle: "Spiek-script (3 regels)",
    jsCueCardsCopy: "Kopieer",
    jsCueCardsCopied: "Spiek-script gekopieerd",
    jsCueCardsCopyFail: "Kopiëren mislukt",
    jsCueCardsBusy: "AI schrijft je spiek-script…",
    jsCueCardsHint: "Klaar om te sollicitieren? Klik op 'Video-pitch' om deze regels op te nemen.",
    jsAddAndLetterHint: "Voeg toe aan tracker én open direct de brief-wizard",
    jsAddedToTracker: "«{title}» in je Sollicitatieoverzicht gezet",
    jsAddFailed: "Toevoegen mislukt",
    jsOpen: "Openen",
    jsSearchFailed: "Zoeken mislukt — probeer opnieuw",

    // Skip-keywords blocklist
    jsSkipTitle: "Skip-woorden — verberg vacatures met deze eisen",
    jsSkipHint: "Voeg woorden of korte zinnen toe die je niet in vacatures wilt zien (bijv. 'HBO', 'gecertificeerd', 'minimaal 5 jaar'). Vacatures met één van deze woorden in de titel of beschrijving worden verborgen.",
    jsSkipCount: "{n} woord(en) actief",
    jsSkippedBadge: "{n} verborgen deze zoekactie",
    jsSkipPlaceholder: "bv. HBO",
    jsSkipAdd: "Toevoegen",
    jsSkipRemove: "Verwijder",
    jsSkipSaveFail: "Opslaan mislukt",
    jsSkipSugInsightsTitle: "AI-suggesties uit no_fit-analyses",
    jsSkipSugInsightsHint: "vaak-terugkerende gaps in je match-insights",
    jsSkipSugCvTitle: "Gaps t.o.v. je CV",
    jsSkipSugCvHint: "termen die vaak in vacatures staan maar niet op jouw CV",
    jsSkipSugLoading: "Suggesties berekenen…",
    jsSkipSugDismiss: "Nooit meer voorstellen",
    // Skip-reason hover-tooltip on the "N verborgen" badge.
    jsSkipReasonTitle: "Waarom deze vacatures verborgen zijn",
    jsSkipReasonMatched: "matchte skip-woord(en):",

    // Profile → dismissed skip-suggestions overview.
    profSkipTitle: "Afgewezen skip-suggesties",
    profSkipHint: "Suggesties waarvan je met × zei dat we ze nooit meer moeten aanraden. Klik op ↺ om er eentje weer beschikbaar te maken.",
    profSkipCount: "{n} afgewezen",
    profSkipLoading: "Laden…",
    profSkipEmpty: "Nog geen suggesties afgewezen.",
    profSkipUndo: "Herstel — mag opnieuw voorgesteld worden",
    profSkipUndone: "\"{kw}\" mag weer voorgesteld worden",
    profSkipUndoFail: "Herstellen mislukt",

    // Skip history — tab in Vacatures Zoeken.
    jsTabHistory: "Geschiedenis",
    jsHistoryTitle: "Geskipte vacatures — historie",
    jsHistoryCount: "{n} regels",
    jsHistoryClear: "Wis geschiedenis",
    jsHistoryClearConfirm: "Weet je zeker dat je de hele skip-geschiedenis wilt wissen?",
    jsHistoryCleared: "Skip-geschiedenis gewist",
    jsHistoryClearFail: "Wissen mislukt",
    jsHistoryLoading: "Geschiedenis laden…",
    jsHistoryEmptyTitle: "Nog niets geskipt",
    jsHistoryEmptyHint: "Zodra een zoekopdracht vacatures op basis van je skip-woorden verbergt, verschijnen ze hier.",
    jsHistoryDate: "Datum",
    jsHistoryQuery: "Zoekopdracht",
    jsHistoryJob: "Vacature",
    jsHistoryMatched: "Match",
    jsHistoryOpenTip: "Klik voor opties om deze vacature alsnog te openen",
    // Restore = Skip Word Undo — dialog dat verschijnt bij klik op een
    // history-rij met een matched skip-woord.
    jsRestoreTitle: "Deze vacature is verborgen",
    jsRestoreIntro: "Ze werd geskipt omdat je zoekfilter deze skip-woord(en) blokkeert:",
    jsRestoreQuestion: "Wat wil je doen?",
    jsRestoreOpenOnly: "Alleen deze vacature openen",
    jsRestoreOpenOnlyHint: "Opent de URL in een nieuw tabblad — je skip-woorden blijven staan.",
    jsRestoreTemp: "Skip-woord tijdelijk uitschakelen",
    jsRestoreTempHint: "Blijft uit voor deze sessie zodat vergelijkbare vacatures nu wel verschijnen. Bij herladen keert het skip-woord terug.",
    jsRestorePermanent: "Skip-woord permanent verwijderen",
    jsRestorePermanentHint: "Haalt het woord voorgoed uit je blocklist.",
    jsRestoreCancel: "Annuleren",
    jsRestoreDone: "{n} skip-woord(en) tijdelijk uitgeschakeld voor deze sessie",
    jsRestoreDoneOne: "Skip-woord «{kw}» tijdelijk uitgeschakeld",
    jsRestoreRemovedOne: "Skip-woord «{kw}» permanent verwijderd",
    // Actief chipje in de skip-keywords bar dat toont hoeveel woorden nu
    // tijdelijk zijn uitgezet (via Skip Word Undo).
    jsBypassBadge: "{n} tijdelijk uit",
    jsBypassClear: "Herstel alle",
    jsBypassRestored: "Skip-woorden hersteld",
    jsBadgeVia: "via",

    // Branche chips
    jsBranches: "Branche",
    jsBrancheAll: "Alle",
    jsBrancheClear: "wis filter",

    // Employment type chips
    jsEmployment: "Dienstverband",
    jsEmploymentAll: "Alle",
    jsEmploymentFulltime: "Fulltime",
    jsEmploymentParttime: "Parttime",
    jsEmploymentContract: "Freelance / Contract",
    jsEmploymentIntern: "Stage",
    jsEmploymentClear: "wis dienstverband",

    // CV match
    jsMatchTitle: "Match met mijn CV",
    jsMatchBody: "Onze AI vergelijkt jouw actieve CV met alle vacatures en geeft per resultaat een match-score. Sleep de slider om vacatures met een lagere score te verbergen.",
    jsMatchRun: "Bereken match",
    jsMatchRerun: "Opnieuw berekenen",
    jsMatchRunning: "Analyseren…",
    jsMatchThreshold: "Min. match {pct}%",
    jsMatchFiltered: "{n} verborgen",
    jsMatchNoneAboveThreshold: "Geen vacatures boven de match-drempel. Verlaag de slider of pas je zoekopdracht aan.",
    jsMatchDone: "{n} vacatures gescoord",
    jsMatchFailed: "Match-analyse mislukt",

    // Weekly Match Radar
    jsRadarTitle: "Wekelijkse match-radar",
    jsRadarBody: "Zet aan en we mailen je elke maandag de top-5 nieuwe vacatures met ≥ 70% match op je CV — gebaseerd op je huidige zoekopdracht.",
    // Match Radar Insights (analytics panel above the toggle)
    mrInsightsTitle: "Match Radar · afgelopen 30 dagen",
    mrInsights30dLabel: "Matches (30 dagen)",
    mrInsightsTrendLabel: "Vs. vorige 30 dagen",
    mrInsightsRunsLabel: "Radar-runs",
    mrInsightsLastRun: "Laatst · {date}",
    mrInsightsNextRun: "Volgende run · {date}",
    mrInsightsWeeklyLabel: "Wekelijks verloop (laatste 8 weken)",
    mrInsightsTopCats: "Top branches",
    jsRadarActiveOn: "Actief voor «{q}» in {loc}",
    jsRadarOn: "Match-radar staat aan — je krijgt maandag je eerste update",
    jsRadarOff: "Match-radar uitgeschakeld",
    jsRadarNeedQuery: "Doe eerst een zoekopdracht voor je de radar aanzet",
    jsRadarSaveFailed: "Opslaan mislukt",
    jsRadarUnsubDone: "Match-radar uitgeschakeld — je ontvangt geen wekelijkse updates meer",

    // Landing highlight (job search)
    landJobsEyebrow: "Nieuw · Vacatures zoeken",
    landJobsTitle: "Doorzoek elk groot vacatureplatform vanuit één plek",
    landJobsBody: "JobGrid scant LinkedIn, Indeed, Glassdoor, Nationale Vacaturebank, Jobbird, Striive, Twago, Randstad Freelance, Freelance.nl en Adzuna in één keer. Klik één keer om een vacature aan je tracker toe te voegen — de omschrijving wordt automatisch bewaard, ook als de originele link later offline gaat. En bewaar favorieten of laat de wekelijkse Match-Radar nieuwe hits direct in je inbox brengen.",
    landJobsBullet1: "Realtime zoeken op miljoenen vacatures — 10 bronnen tegelijk",
    landJobsBullet2: "Multi-select filters: branche, dienstverband, locatie",
    landJobsBullet3: "AI Match: alleen vacatures ≥ 50% match met jouw CV",
    landJobsBullet4: "Één klik: van vacature naar motivatiebrief — direct in de wizard",

    // Dashboard widget promo
    jsWidgetEyebrow: "Nieuw",
    jsWidgetTitle: "Vind vacatures — zonder tabs te wisselen",
    jsWidgetBody: "Doorzoek LinkedIn, Indeed, Glassdoor en Adzuna in één keer.",
    jsWidgetCta: "Open Vacatures zoeken",

    // Video Cover Letter
    vidOpenCta: "Videobrief opnemen",
    vidTitle: "Videobrief · AI-gecoachte pitch",
    vidScriptEyebrow: "Jouw script (± {seconds}s spreken)",
    vidScriptHint: "AI stelt een script op maat van deze vacature — pas 'm gerust aan voordat je gaat opnemen. Max {seconds} seconden.",
    vidScriptLoading: "AI schrijft jouw video-script…",
    vidScriptFail: "Script maken mislukt — probeer het opnieuw",
    vidStartRecord: "Camera aan & opnemen",
    vidRecord: "Start opname",
    vidStop: "Stop opname",
    vidRetake: "Opnieuw opnemen",
    vidUpload: "Uploaden & AI-feedback",
    vidBack: "Terug",
    vidPrivacyHint: "De opname blijft privé totdat je de deel-link doorstuurt.",
    vidCamDenied: "Toegang tot camera/microfoon geweigerd — sta het toe in je browser.",
    vidUploadFail: "Upload mislukt — probeer het opnieuw",
    vidProcessing: "Video verwerken…",
    vidProcessingHint: "We transcriberen je pitch met Whisper en scoren 'm met Gemini.",
    vidPreviewInfo: "Opname klaar · {seconds}s. Bekijk 'm terug of neem opnieuw op.",
    vidShareEyebrow: "Deel-link voor de recruiter",
    vidShareHint: "Iedereen met deze link kan de video afspelen — je persoonlijke CV blijft privé.",
    vidCopy: "Kopieer",
    vidCopied: "Gekopieerd!",
    vidMatchScore: "Match met vacature",
    vidClarity: "Verstaanbaarheid",
    vidStrengths: "Sterke punten",
    vidTips: "Verbetertips",
    vidTranscript: "Transcript",
    vidDone: "Klaar",
    vidExistingTitle: "Je hebt al een videobrief voor deze motivatie",
    vidExistingBody: "Nieuwe opname vervangt de oude niet automatisch —",
    vidExistingOpen: "bekijk huidige videobrief",
    vidDelete: "Verwijderen",
    vidDeleteConfirm: "Videobrief permanent verwijderen? De deel-link vervalt direct.",
    vidDeleted: "Videobrief verwijderd",
    vidDeleteFail: "Verwijderen mislukt",

    // Video Cover Letter — public playback
    vidPublicEyebrow: "Videobrief",
    vidPublicTitle: "Een videobrief speciaal voor jou",
    vidPublicFooter: "Aangeboden via JobGrid — de rustige sollicitatie-tool.",
    vidPublicMissing: "Deze videobrief bestaat niet meer",
    vidPublicMissingHint: "De sollicitant heeft de video verwijderd of de link is niet correct.",
    vidPublicIdentifyTitle: "Wie ben jij? (optioneel)",
    vidPublicIdentifyHint: "Vul je naam of bedrijf in — dan ziet de sollicitant wie z'n pitch bekeek.",
    vidPublicIdentifyNamePh: "Voornaam + achternaam",
    vidPublicIdentifyCompanyPh: "Bedrijf",
    vidPublicIdentifyCta: "Bevestig",
    vidPublicIdentifySaved: "Bedankt — bekeken als {name}",

    // Owner-side analytics panel (VideoLetterModal)
    vidStatsTitle: "Wie heeft je pitch bekeken?",
    vidStatsRefresh: "Vernieuwen",
    vidStatsRefreshing: "Vernieuwen…",
    vidStatsViews: "Views",
    vidStatsIdentified: "Bekend",
    vidStatsAnon: "Anoniem",
    vidStatsTop: "Langst bekeken door",
    vidStatsAnonRow: "Anonieme kijker",
    vidStatsEmpty: "Nog geen views — deel de link met een recruiter.",
    vidStatsAnonOnly: "Alle views waren anoniem — recruiters kunnen hun naam opgeven op de publieke pagina.",

    // Auto-cue teleprompter — reads the script straight off the screen
    // while recording. Play/Pause/Redo controls sit above the scroll box.
    vidAutoCueEyebrow: "Auto-cue — lees mee",
    vidAutoCueEmpty: "Geen script beschikbaar — schrijf er eentje via de wizard.",
    vidAutoCueStart: "Start",
    vidAutoCuePause: "Pauze",
    vidAutoCueRedo: "Opnieuw",

    // QR-code hint on the success screen — tells the user the letter PDF
    // now automatically embeds a QR-code linking to this video.
    vidQrEyebrow: "QR-code op je motivatiebrief",
    vidQrHint: "We plakken automatisch een QR-code onderaan je motivatiebrief-PDF. De recruiter scant 'm met z'n telefoon en start jouw videobrief direct.",

    // Elevator-pitch mode — one generic video usable across many letters.
    vidElevatorTitle: "Elevator pitch · algemene videobrief",
    vidElevatorEyebrow: "Elevator pitch",
    vidElevatorCardTitle: "Neem één keer een 60-seconden pitch op",
    vidElevatorCardBody: "Deze video wordt automatisch als QR gekoppeld aan je CV én aan elke motivatiebrief zonder eigen video. Ideaal voor snel meerdere sollicitaties.",
    vidElevatorCta: "Elevator pitch opnemen",
    vidElevatorReplace: "Vervang elevator pitch",
    vidElevatorHasOne: "Actieve elevator pitch — al {views} keer bekeken.",
    vidViewCount: "{n} keer bekeken door recruiters",

    // Custom QR-label — laat gebruikers de tekst onder de QR-code op de
    // PDF's aanpassen ("Watch my 60s pitch", "Zie ook mijn video"…). Leeg
    // → automatisch de standaard voor de taal ("Bekijk mijn videobrief").
    vidQrLabelTitle: "QR-tekst op PDF",
    vidQrLabelHint: "Deze tekst verschijnt onder de QR-code op je CV en motivatiebrief. Leeg laten = automatisch de standaardtekst voor je taal.",
    vidQrLabelPlaceholder: "Bijv. Zie ook mijn 60s pitch",
    vidQrLabelSave: "Opslaan",
    vidQrLabelSaving: "Opslaan…",
    vidQrLabelSaved: "QR-tekst opgeslagen",
    vidQrLabelFail: "QR-tekst opslaan mislukt",

    // ThinkingLoader — playful rotating status copy for long AI tasks.
    // Cycled every ~2.2s so users see the app "thinking" instead of a
    // frozen spinner. Keep each line under ~50 chars for compact button rows.
    thinkMatch1: "CV grondig aan het doorlezen…",
    thinkMatch2: "Vaardigheden aan het inventariseren…",
    thinkMatch3: "Vacatures één voor één afkloppen…",
    thinkMatch4: "Rood potlood erbij pakken…",
    thinkMatch5: "Match-scores aan het berekenen…",
    thinkMatch6: "Even nog een tweede blik werpen…",
    thinkMatch7: "Bijna klaar — puntjes op de i…",

    thinkLetter1: "Vacature aan het ontleden…",
    thinkLetter2: "Jouw sterke punten opsnorren…",
    thinkLetter3: "Toon en stem afstemmen…",
    thinkLetter4: "Zinnen fijnslijpen…",
    thinkLetter5: "Alinea-structuur strak trekken…",
    thinkLetter6: "Laatste hand aan de brief leggen…",

    thinkPrep1: "Bedrijf aan het googlen…",
    thinkPrep2: "Missie en cultuur uitpluizen…",
    thinkPrep3: "Slimme interviewvragen bedenken…",
    thinkPrep4: "STAR-antwoorden voorbereiden…",
    thinkPrep5: "Valkuilen in kaart brengen…",
    thinkPrep6: "Coaching-tips op maat maken…",

    thinkInsight1: "Vacature-tekst aan het scannen…",
    thinkInsight2: "Sterke punten benoemen…",
    thinkInsight3: "Eventuele gaps signaleren…",
    thinkInsight4: "Verdict-samenvatting formuleren…",
    thinkInsight5: "Bijna daar — inzicht bijna gereed…",

    thinkBulk1: "Vacatures aan het verzamelen…",
    thinkBulk2: "Per vacature de match aan het scoren…",
    thinkBulk3: "AI aan het werk zetten — dit kan even duren…",
    thinkBulk4: "Nog even, meerdere vacatures tegelijk…",
    thinkBulk5: "Rapporten aan het samenstellen…",
    thinkBulk6: "Bijna klaar — resultaten bundelen…",

    thinkResume1: "Ervaring en vaardigheden aan het ordenen…",
    thinkResume2: "Krachtige opsommingen schrijven…",
    thinkResume3: "Taal aan het polijsten…",
    thinkResume4: "Onnodige woorden schrappen…",
    thinkResume5: "Structuur toetsen aan best practices…",
    thinkResume6: "Laatste hand aan je CV leggen…",

    thinkEmail1: "Toon en aanhef bepalen…",
    thinkEmail2: "Kernboodschap samenvatten…",
    thinkEmail3: "Zinnen fijnslijpen…",
    thinkEmail4: "Bijna verzonden — even nog…",

    thinkGeneric1: "Even geduld — ik ben bezig…",
    thinkGeneric2: "Nog een stap of twee…",
    thinkGeneric3: "Bijna klaar…",
    thinkGeneric4: "Ik doe m'n best — het lukt zo…",
    thinkGeneric5: "Nog even volhouden…",
};

export default nl;
